function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
}
function gm_authFailure() {
  $(".map-section").addClass("map-section--load-error"), $(
    ".map-section__container"
  ).remove(), $(".map-section__link").remove(), $(
    ".map-section__overlay"
  ).after(
    '<div class="errors text-center">' + theme.strings.authError + "</div>"
  );
}
function onYouTubeIframeAPIReady() {
  theme.YouTubeVideos.loadVideos();
}
(window.theme = window.theme || {
}), (window.home_video_list = window.home_video_list || {
}), (window.theme = window.theme || {}), (theme.Sections = function() {
  (this.constructors = {}), (this.instances = []), $(document)
    .on("shopify:section:load", this._onSectionLoad.bind(this))
    .on("shopify:section:unload", this._onSectionUnload.bind(this))
    .on("shopify:section:select", this._onSelect.bind(this))
    .on("shopify:section:deselect", this._onDeselect.bind(this))
    .on("shopify:block:select", this._onBlockSelect.bind(this))
    .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
}), (theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(e, t) {
    var i = $(e),
      o = i.attr("data-section-id"),
      n = i.attr("data-section-type");
    if (((t = t || this.constructors[n]), !_.isUndefined(t))) {
      var a = _.assignIn(new t(e), { id: o, type: n, container: e });
      this.instances.push(a);
    }
  },
  _onSectionLoad: function(e) {
    var t = $("[data-section-id]", e.target)[0];
    t && this._createInstance(t);
  },
  _onSectionUnload: function(e) {
    this.instances = _.filter(this.instances, function(t) {
      var i = t.id === e.detail.sectionId;
      return i && _.isFunction(t.onUnload) && t.onUnload(e), !i;
    });
  },
  _onSelect: function(e) {
    var t = _.find(this.instances, function(t) {
      return t.id === e.detail.sectionId;
    });
    !_.isUndefined(t) && _.isFunction(t.onSelect) && t.onSelect(e);
  },
  _onDeselect: function(e) {
    var t = _.find(this.instances, function(t) {
      return t.id === e.detail.sectionId;
    });
    !_.isUndefined(t) && _.isFunction(t.onDeselect) && t.onDeselect(e);
  },
  _onBlockSelect: function(e) {
    var t = _.find(this.instances, function(t) {
      return t.id === e.detail.sectionId;
    });
    !_.isUndefined(t) && _.isFunction(t.onBlockSelect) && t.onBlockSelect(e);
  },
  _onBlockDeselect: function(e) {
    var t = _.find(this.instances, function(t) {
      return t.id === e.detail.sectionId;
    });
    !_.isUndefined(t) &&
      _.isFunction(t.onBlockDeselect) &&
      t.onBlockDeselect(e);
  },
  register: function(e, t) {
    (this.constructors[e] = t), $("[data-section-type=" + e + "]").each(
      function(e, i) {
        this._createInstance(i, t);
      }.bind(this)
    );
  }
})), (window.slate = window.slate || {}), (slate.rte = {
  wrapTable: function() {
    $(".rte table").wrap('<div class="rte__table-wrapper"></div>');
  },
  iframeReset: function() {
    var e = $(
      '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'
    ),
      t = e.add(".rte iframe#admin_bar_iframe");
    e.each(function() {
      $(this).wrap('<div class="video-wrapper"></div>');
    }), t.each(function() {
      this.src = this.src;
    });
  }
}), (window.slate = window.slate || {}), (slate.a11y = {
  pageLinkFocus: function(e) {
    var t = "js-focus-hidden";
    e
      .first()
      .attr("tabIndex", "-1")
      .focus()
      .addClass(t)
      .one("blur", function() {
        e.first().removeClass(t).removeAttr("tabindex");
      });
  },
  focusHash: function() {
    var e = window.location.hash;
    e && document.getElementById(e.slice(1)) && this.pageLinkFocus($(e));
  },
  bindInPageLinks: function() {
    $("a[href*=#]").on(
      "click",
      function(e) {
        this.pageLinkFocus($(e.currentTarget.hash));
      }.bind(this)
    );
  },
  trapFocus: function(e) {
    var t = e.namespace ? "focusin." + e.namespace : "focusin";
    e.$elementToFocus || (e.$elementToFocus = e.$container), e.$container.attr(
      "tabindex",
      "-1"
    ), e.$elementToFocus.focus(), $(document).off("focusin"), $(
      document
    ).on(t, function(t) {
      e.$container[0] === t.target ||
        e.$container.has(t.target).length ||
        e.$container.focus();
    });
  },
  removeTrapFocus: function(e) {
    var t = e.namespace ? "focusin." + e.namespace : "focusin";
    e.$container &&
      e.$container.length &&
      e.$container.removeAttr("tabindex"), $(document).off(t);
  }
}), (theme.Images = {
  preload: function(e, t) {
    "string" == typeof e && (e = [e]);
    for (var i, o = 0; o < e.length; o++)
      (i = e[o]), this.loadImage(this.getSizedImageUrl(i, t));
  },
  loadImage: function(e) {
    new Image().src = e;
  },
  switchImage: function(e, t, i) {
    var o = this.imageSize(t.src), n = this.getSizedImageUrl(e.src, o);
    i ? i(n, e, t) : (t.src = n);
  },
  imageSize: function(e) {
    var t = e.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
    );
    return null === t ? null : t[1];
  },
  getSizedImageUrl: function(e, t) {
    if (null == t) return e;
    if ("master" === t) return this.removeProtocol(e);
    var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
    if (null != i) {
      var o = e.split(i[0]), n = i[0];
      return this.removeProtocol(o[0] + "_" + t + n);
    }
    return null;
  },
  removeProtocol: function(e) {
    return e.replace(/http(s)?:/, "");
  }
}), (theme.Currency = {
  formatMoney: function(e, t) {
    function i(e, t, i, o) {
      if (((t = t || 2), (i = i || ","), (o = o || "."), isNaN(e) || null == e))
        return 0;
      var n = (e = (e / 100).toFixed(t)).split(".");
      return (
        n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
        (n[1] ? o + n[1] : "")
      );
    }
    "string" == typeof e && (e = e.replace(".", ""));
    var o = "", n = /\{\{\s*(\w+)\s*\}\}/, a = t || "${{amount}}";
    switch (a.match(n)[1]) {
      case "amount":
        o = i(e, 2);
        break;
      case "amount_no_decimals":
        o = i(e, 0);
        break;
      case "amount_with_comma_separator":
        o = i(e, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        o = i(e, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        o = i(e, 0, " ");
    }
    return a.replace(n, o);
  }
}), (slate.Variants = (function() {
  function e(e) {
    (this.$container = e.$container), (this.product =
      e.product), (this.singleOptionSelector =
      e.singleOptionSelector), (this.originalSelectorId =
      e.originalSelectorId), (this.enableHistoryState =
      e.enableHistoryState), (this.currentVariant = this._getVariantFromOptions()), $(
      this.singleOptionSelector,
      this.$container
    ).on("change", this._onSelectChange.bind(this));
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _getCurrentOptions: function() {
      var e = _.map($(this.singleOptionSelector, this.$container), function(e) {
        var t = $(e), i = t.attr("type"), o = {};
        return "radio" === i || "checkbox" === i
          ? !!t[0].checked &&
              ((o.value = t.val()), (o.index = t.data("index")), o)
          : ((o.value = t.val()), (o.index = t.data("index")), o);
      });
      return (e = _.compact(e));
    },
    _getVariantFromOptions: function() {
      var e = this._getCurrentOptions(), t = this.product.variants;
      return _.find(t, function(t) {
        return e.every(function(e) {
          return _.isEqual(t[e.index], e.value);
        });
      });
    },
    _onSelectChange: function() {
      var e = this._getVariantFromOptions();
      this.$container.trigger({ type: "variantChange", variant: e }), e &&
        (this._updateMasterSelect(e), this._updateImages(e), this._updatePrice(
          e
        ), this._updateSKU(e), (this.currentVariant = e), this
          .enableHistoryState && this._updateHistoryState(e));
    },
    _updateImages: function(e) {
      var t = e.featured_image || {},
        i = this.currentVariant.featured_image || {};
      e.featured_image &&
        t.src !== i.src &&
        this.$container.trigger({ type: "variantImageChange", variant: e });
    },
    _updatePrice: function(e) {
      (e.price === this.currentVariant.price &&
        e.compare_at_price === this.currentVariant.compare_at_price) ||
        this.$container.trigger({ type: "variantPriceChange", variant: e });
    },
    _updateSKU: function(e) {
      e.sku === this.currentVariant.sku ||
        this.$container.trigger({ type: "variantSKUChange", variant: e });
    },
    _updateHistoryState: function(e) {
      if (history.replaceState && e) {
        var t =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?variant=" +
          e.id;
        window.history.replaceState({ path: t }, "", t);
      }
    },
    _updateMasterSelect: function(e) {
      $(this.originalSelectorId, this.$container).val(e.id);
    }
  })), e;
})()), (theme.Drawers = (function() {
  function e(e, t, i) {
    return (this.nodes = {
      $parent: $("html").add("body"),
      $page: $("#PageContainer")
    }), (this.config = $.extend(
      {
        close: ".js-drawer-close",
        open: ".js-drawer-open-" + t,
        openClass: "js-drawer-open",
        dirOpenClass: "js-drawer-open-" + t
      },
      i
    )), (this.position = t), (this.$drawer = $("#" + e)), !!this.$drawer
      .length && ((this.drawerIsOpen = !1), void this.init());
  }
  return (e.prototype.init = function() {
    $(this.config.open).on("click", $.proxy(this.open, this)), this.$drawer.on(
      "click",
      this.config.close,
      $.proxy(this.close, this)
    );
  }), (e.prototype.open = function(e) {
    var t = !1;
    return e ? e.preventDefault() : (t = !0), e &&
      e.stopPropagation &&
      (e.stopPropagation(), (this.$activeSource = $(e.currentTarget))), this
      .drawerIsOpen && !t
      ? this.close()
      : (this.$drawer.prepareTransition(), this.nodes.$parent.addClass(
          this.config.openClass + " " + this.config.dirOpenClass
        ), (this.drawerIsOpen = !0), slate.a11y.trapFocus({
          $container: this.$drawer,
          namespace: "drawer_focus"
        }), this.config.onDrawerOpen &&
          "function" == typeof this.config.onDrawerOpen &&
          !t &&
          this.config.onDrawerOpen(), this.$activeSource &&
          this.$activeSource.attr("aria-expanded") &&
          this.$activeSource.attr(
            "aria-expanded",
            "true"
          ), this.bindEvents(), this);
  }), (e.prototype.close = function() {
    this.drawerIsOpen &&
      ($(document.activeElement).trigger(
        "blur"
      ), this.$drawer.prepareTransition(), this.nodes.$parent.removeClass(
        this.config.dirOpenClass + " " + this.config.openClass
      ), (this.drawerIsOpen = !1), slate.a11y.removeTrapFocus({
        $container: this.$drawer,
        namespace: "drawer_focus"
      }), this.unbindEvents());
  }), (e.prototype.bindEvents = function() {
    this.nodes.$parent.on(
      "keyup.drawer",
      $.proxy(function(e) {
        return 27 !== e.keyCode || (this.close(), !1);
      }, this)
    ), this.nodes.$page.on("touchmove.drawer", function() {
      return !1;
    }), this.nodes.$page.on(
      "click.drawer",
      $.proxy(function() {
        return this.close(), !1;
      }, this)
    );
  }), (e.prototype.unbindEvents = function() {
    this.nodes.$page.off(".drawer"), this.nodes.$parent.off(".drawer");
  }), e;
})()), (window.theme = window.theme || {}), (theme.Header = (function() {
  var e = { header: ".site-header", navigation: "ul#menu-primary-header" };
  return {
    init: function() {
      $(e.header).length &&
        ($(".sub-active")
          .closest(".parent-menu-item")
          .addClass("current-menu-ancestor"), $(document.body).hasClass(
          "sticky-header"
        ) &&
          ($(window).on("scroll", function() {
            var t = 5;
            $(document.body).hasClass("header-slider-top") &&
              (t =
                $("#header-slider").height() +
                $(
                  "#un-header-minimized"
                ).height()), $(window).scrollTop() > t ? ($(e.header).addClass("minimized"), $(document.body).addClass("sticky-header-show")) : ($(e.header).removeClass("minimized"), $(document.body).removeClass("sticky-header-show"));
          }), $(window)
            .on("resize", function() {
              if (768 > $(window).width()) {
                var t = $(e.header).height();
                $("#un-header-minimized").height(t);
              } else $("#un-header-minimized").removeAttr("style");
            })
            .trigger("resize")));
    }
  };
})()), (window.theme = window.theme || {}), (theme.Search = (function() {
  var e = "#search-modal";
  return {
    init: function() {
      $(e).length &&
        (function() {
          function e() {
            var e = r.val(), t = "";
            if (
              (0 < a.find(".product-cats").length &&
                (t = a.find(".product-cats input:checked").val()), 2 > e.length)
            )
              a
                .removeClass("searching found-products found-no-product")
                .addClass("invalid-length");
            else {
              a
                .removeClass("found-products found-no-product")
                .addClass("searching");
              var i = e + t;
              if (i in n) {
                var l = n[i];
                a.removeClass("searching"), a.addClass(
                  "found-products"
                ), c.find(".rt-unero").html(l.products), $(
                  document.body
                ).trigger("unero_ajax_search_request_success", [c]), c
                  .find(".rt-unero, .buttons")
                  .slideDown(function() {
                    a.removeClass("invalid-length");
                  }), a.addClass("searched actived");
              } else {
                var d = "/search?view=ajax&" + s.serialize();
                o = $.get(d, function(e) {
                  var t = $(e).html();
                  a.removeClass(
                    "searching"
                  ), a.addClass("found-products"), c.find(".rt-unero").html(t), c.find(".rt-unero, .buttons").slideDown(function() {
                    a.removeClass("invalid-length");
                  }), $(
                    document.body
                  ).trigger("unero_ajax_search_request_success", [
                    c
                  ]), (n[i] = { found: !0, products: t }), a.addClass("searched actived");
                });
              }
              $(document.body).on("unero_ajax_search_request_success", function(
                e,
                t
              ) {
                t.find("img.lazy").lazyload({ threshold: 1e3 });
              });
            }
          }
          var t,
            i,
            o = null,
            n = {},
            a = $("#search-modal"),
            s = a.find("form"),
            r = s.find("input.search-field"),
            c = a.find(".search-results");
          a
            .on("keyup", ".search-field", function(t) {
              var i = !1;
              void 0 === t.which
                ? (i = !0)
                : "number" == typeof t.which &&
                    0 < t.which &&
                    (i =
                      !t.ctrlKey &&
                      !t.metaKey &&
                      !t.altKey), i && (o && o.abort(), e());
            })
            .on("change", ".product-cats input", function() {
              o && o.abort(), e();
            })
            .on("focusout", ".search-field", function() {
              2 > r.val().length &&
                c.find(".rt-unero, .buttons").slideUp(function() {
                  a.removeClass(
                    "searching searched actived found-products found-no-product invalid-length"
                  );
                });
            }), (t = $(".header-layout-4").find("#search-modal")), (i = t.find(
            "input.search-field"
          )), 0 >= t.length ||
            ($(window).on("scroll", function() {
              10 < $(window).scrollTop() &&
                t.removeClass("show found-products searched");
            }), $(document).on("click", function(e) {
              var i = e.target;
              $(i).closest(".extra-menu-item").hasClass("menu-item-search") ||
                t.removeClass(
                  "searching searched found-products found-no-product invalid-length"
                );
            }), t.on("click", ".t-icon", function(e) {
              t.hasClass("actived") &&
                (e.preventDefault(), i.val(""), t.removeClass(
                  "searching searched actived found-products found-no-product invalid-length"
                ));
            }));
        })();
    }
  };
})()), (window.theme = window.theme || {
}), (theme.CurrencyPicker = (function() {
  var e = {
    currency: ".currency_switcher",
    currencyPicker: ".currency_switcher .currency",
    currencyActive: ".currency_switcher .currency.active"
  },
    t = {
      currency_format: "",
      shop_currency: "",
      default_currency: "",
      money_with_currency_format: "",
      money_format: ""
    };
  return {
    init: function() {
      $(e.currency).length &&
        (function() {
          var i = $(e.currency).first().closest(".currency-wrapper");
          (t.currency_format = i
            .find(".currency_format")
            .val()), (t.shop_currency = i
            .find(".shop_currency")
            .val()), (t.default_currency = i
            .find(".default_currency")
            .val()), (t.money_with_currency_format = i
            .find(".money_with_currency_format")
            .val()), (t.money_format = i
            .find(".money_format")
            .val()), (Currency.format = t.currency_format);
          var o = t.shop_currency;
          (Currency.moneyFormats[o].money_with_currency_format =
            t.money_with_currency_format), (Currency.moneyFormats[
            o
          ].money_format =
            t.money_format);
          var n = t.default_currency;
          try {
            var a = Currency.cookie.read();
            $("span.money span.money").each(function() {
              $(this).parents("span.money").removeClass("money");
            }), $("span.money").each(function() {
              $(this).attr("data-currency-" + t.shop_currency, $(this).html());
            }), null == a
              ? (o === n
                  ? (Currency.currentCurrency = n)
                  : Currency.convertAll(o, n), Currency.cookie.write(n))
              : $(e.currency).length &&
                  0 === $(e.currency + " .currency[data-code=" + a + "]").size()
                  ? ((Currency.currentCurrency = o), Currency.cookie.write(o))
                  : a === o
                      ? (Currency.currentCurrency = o)
                      : Currency.convertAll(o, a), $(
              e.currency
            ).on("click", ".currency:not(.active)", function() {
              var t = $(this).attr("data-code");
              Currency.convertAll(
                Currency.currentCurrency,
                t
              ), $(e.currencyPicker).removeClass("active"), $(e.currencyPicker).closest("li").removeClass("actived"), $(this).addClass("active"), $(this).closest("li").addClass("actived"), $(".menu-item-currency.currency-wrapper").find("span.current").html($(this).html() + '<span class="toggle-children i-icon arrow_carrot-down"></span>');
            }), window.selectCallback, $(
              "body"
            ).on("ajaxCart.afterCartLoad", function() {
              Currency.convertAll(
                o,
                $(e.currencyActive).attr("data-code")
              ), $(e.currencyPicker).removeClass("active"), $(e.currencyPicker).closest("li").removeClass("actived"), $(e.currency + " .currency[data-code=" + Currency.currentCurrency + "]").addClass("active"), $(e.currency + " .currency[data-code=" + Currency.currentCurrency + "]").closest("li").addClass("actived"), $(".menu-item-currency.currency-wrapper").find("span.current").html(Currency.currentCurrency + '<span class="toggle-children i-icon arrow_carrot-down"></span>');
            }), $(e.currencyPicker).removeClass("active"), $(e.currencyPicker)
              .closest("li")
              .removeClass("actived"), $(
              e.currency +
                " .currency[data-code=" +
                Currency.currentCurrency +
                "]"
            ).addClass("active"), $(
              e.currency +
                " .currency[data-code=" +
                Currency.currentCurrency +
                "]"
            )
              .closest("li")
              .addClass("actived"), $(".menu-item-currency.currency-wrapper")
              .find("span.current")
              .html(
                Currency.currentCurrency +
                  '<span class="toggle-children i-icon arrow_carrot-down"></span>'
              );
          } catch (e) {
            console.log(e.message);
          }
        })();
    },
    convert: function(i) {
      if ($(e.currency).length)
        try {
          $(i).each(function() {
            $(this).attr("data-currency-" + t.shop_currency, $(this).html());
          }), Currency.convertAll(
            t.shop_currency,
            Currency.cookie.read(),
            i,
            t.currency_format
          );
        } catch (e) {
          console.log(e.message);
        }
    }
  };
})()), (function() {
  function e(e) {
    var t = document.createElement("a");
    return (t.ref = e), t.hostname;
  }
  var t = $(".return-link");
  document.referrer &&
    t.length &&
    window.history.length &&
    t.one("click", function(t) {
      t.preventDefault();
      var i = e(document.referrer);
      return e(window.location.href) === i && history.back(), !1;
    });
})(), (theme.Slideshow = (function() {
  function e(e) {
    (this.$slideshow = $(e)), (this.$wrapper = this.$slideshow.closest(
      "." + i.wrapper
    )), (this.$pause = this.$wrapper.find(
      "." + i.pauseButton
    )), (this.settings = {
      accessibility: !0,
      arrows: !0,
      dots: !1,
      fade: !0,
      draggable: !0,
      touchThreshold: 20,
      autoplay: this.$slideshow.data("autoplay"),
      autoplaySpeed: this.$slideshow.data("speed")
    }), this.$slideshow.on(
      "beforeChange",
      function(e, o, n, a) {
        var s = o.$slider,
          r = s.find("." + i.currentSlide),
          c = s.find('.slideshow__slide[data-slick-index="' + a + '"]');
        if (t(r)) {
          var l = r.find("." + i.video), d = l.attr("id");
          theme.SlideshowVideo.pauseVideo(d), l.attr("tabindex", "-1");
        }
        if (t(c)) {
          var u = c.find("." + i.video),
            h = u.attr("id"),
            p = u.hasClass(i.videoBackground);
          p ? theme.SlideshowVideo.playVideo(h) : u.attr("tabindex", "0");
        }
      }.bind(this)
    ), this.$slideshow.on(
      "init",
      function(e, t) {
        var o = t.$slider,
          n = t.$list,
          a = this.$wrapper,
          s = this.settings.autoplay;
        n.removeAttr("aria-live"), a.on("focusin", function(e) {
          a.has(e.target).length &&
            (n.attr("aria-live", "polite"), s && o.slick("slickPause"));
        }), a.on("focusout", function(e) {
          if (a.has(e.target).length && (n.removeAttr("aria-live"), s)) {
            if ($(e.target).hasClass(i.closeVideoBtn)) return;
            o.slick("slickPlay");
          }
        }), t.$dots &&
          t.$dots.on("keydown", function(e) {
            37 === e.which &&
              o.slick(
                "slickPrev"
              ), 39 === e.which && o.slick("slickNext"), (37 === e.which || 39 === e.which) && t.$dots.find(".slick-active button").focus();
          });
      }.bind(this)
    ), this.$slideshow.slick(this.settings), this.$pause.on(
      "click",
      this.togglePause.bind(this)
    ), (function() {
      function e() {
        var e = $(window).height();
        $("." + i.slideshowWindow).css("height", e);
      }
      $("." + i.slideshowWindow).length &&
        (e(), $(window).on("resize", function() {
          e();
        }));
    })();
  }
  function t(e) {
    return e.find("." + i.video).length;
  }
  this.$slideshow = null;
  var i = {
    wrapper: "slideshow-wrapper",
    slideshow: "slideshow",
    slideshowWindow: "slideshow--window",
    imageBackground: "slideshow__image",
    currentSlide: "slick-current",
    video: "slideshow__video",
    videoBackground: "slideshow__video--background",
    closeVideoBtn: "slideshow__video-control--close",
    pauseButton: "slideshow__pause",
    isPaused: "is-paused"
  };
  return (e.prototype.togglePause = function() {
    var e = (function(e) {
      return "#Slideshow-" + e.data("id");
    })(this.$pause);
    this.$pause.hasClass(i.isPaused)
      ? (this.$pause.removeClass(i.isPaused), $(e).slick("slickPlay"))
      : (this.$pause.addClass(i.isPaused), $(e).slick("slickPause"));
  }), e;
})()), (theme.SlideshowVideo = (function() {
  function e(e, o) {
    var n = m[e], a = g[e], s = m[e].$parentSlide;
    if (p) i(n);
    else if (o || (d && u))
      return s.removeClass(y.loading), i(n), void a.playVideo();
    d ||
      (function(e, i) {
        e.playVideo(), (function(e) {
          var t, i, o = $.Deferred();
          return (t = setInterval(function() {
            0 >= e.getCurrentTime() ||
              ((u = !0), clearInterval(t), clearTimeout(i), o.resolve());
          }, 500)), (i = setTimeout(function() {
            clearInterval(t), o.reject();
          }, 4e3)), o;
        })(e)
          .then(function() {
            t(!0);
          })
          .fail(function() {
            t(!1), e.stopVideo();
          })
          .always(function() {
            (d = !0), i.removeClass(y.loading);
          });
      })(a, s);
  }
  function t(e) {
    var t = e ? y.supportsAutoplay : y.supportsNoAutoplay;
    $(document.documentElement).addClass(t), e || (p = !0), (d = !0);
  }
  function i(e) {
    var t = e.$parentSlideshowWrapper, i = e.$parentSlide;
    if ((i.removeClass(y.loading), "background" !== e.status)) {
      switch (($("#" + e.id).attr("tabindex", "0"), e.type)) {
        case "chrome":
        case "background-chrome":
          t.removeClass(y.paused).addClass(y.playing), i
            .removeClass(y.paused)
            .addClass(y.playing);
      }
      i.find("." + y.closeVideoBtn).focus();
    }
  }
  function o(e) {
    var t = e.$parentSlideshowWrapper, i = e.$parentSlide;
    return "background-chrome" === e.type
      ? void n(e.id)
      : ("closed" !== e.status &&
          "background" !== e.type &&
          (t.addClass(y.paused), i.addClass(y.paused)), "chrome" === e.type &&
          "closed" === e.status &&
          (t.removeClass(y.paused), i.removeClass(y.paused)), t.removeClass(
          y.playing
        ), void i.removeClass(y.playing));
  }
  function n(e) {
    var t = m[e],
      i = t.$parentSlideshowWrapper,
      n = t.$parentSlide,
      a = [y.pause, y.playing].join(" ");
    switch (($("#" + t.id).attr("tabindex", "-1"), (t.status =
      "closed"), t.type)) {
      case "background-chrome":
        g[e].mute(), (function(e) {
          var t = $("#" + e)
            .addClass(y.videoBackground)
            .removeClass(y.videoChrome);
          m[e].$parentSlide.addClass(y.slideBackgroundVideo), (m[e].status =
            "background"), c(t);
        })(e);
        break;
      case "chrome":
        g[e].stopVideo(), o(t);
    }
    i.removeClass(a), n.removeClass(a);
  }
  function a(e) {
    return m[e.target.h.id];
  }
  function s(t) {
    var i = m[t];
    switch ((i.$parentSlide.addClass(y.loading), (i.status = "open"), i.type)) {
      case "background-chrome":
        (function(e) {
          $("#" + e)
            .removeAttr("style")
            .removeClass(y.videoBackground)
            .addClass(y.videoChrome), m[e].$parentSlideshowWrapper
            .removeClass(y.slideBackgroundVideo)
            .addClass(y.playing), m[e].$parentSlide
            .removeClass(y.slideBackgroundVideo)
            .addClass(y.playing), (m[e].status = "open");
        })(t), g[t].unMute(), e(t, !0);
        break;
      case "chrome":
        e(t, !0);
    }
    $(document).on("keydown.videoPlayer", function(e) {
      27 === e.keyCode && n(t);
    });
  }
  function r() {
    $("." + y.videoBackground).each(function(e, t) {
      c($(t));
    });
  }
  function c(e) {
    var t = e.closest("." + y.slide);
    if (!t.hasClass(y.slickClone)) {
      var i = t.width(), o = e.width(), n = e.height();
      i / v.ratio < n
        ? ((o = Math.ceil(n * v.ratio)), e
            .width(o)
            .height(n)
            .css({ left: (i - o) / 2, top: 0 }))
        : ((n = Math.ceil(i / v.ratio)), e
            .width(i)
            .height(n)
            .css({
              left: 0,
              top: (n - n) / 2
            })), e.prepareTransition().addClass(y.loaded);
    }
  }
  function l() {
    $(document).on("click.videoPlayer", "." + y.playVideoBtn, function(e) {
      s($(e.currentTarget).data("controls"));
    }), $(document).on("click.videoPlayer", "." + y.closeVideoBtn, function(e) {
      n($(e.currentTarget).data("controls"));
    }), $(window).on(
      "resize.videoPlayer",
      $.debounce(250, function() {
        f && r();
      })
    );
  }
  var d = !1,
    u = !1,
    h = !1,
    p = !1,
    f = !1,
    m = {},
    g = [],
    v = {
      ratio: 16 / 9,
      playerVars: {
        iv_load_policy: 3,
        modestbranding: 1,
        autoplay: 0,
        controls: 0,
        showinfo: 0,
        wmode: "opaque",
        branding: 0,
        autohide: 0,
        rel: 0
      },
      events: {
        onReady: function(i) {
          i.target.setPlaybackQuality("hd1080");
          var o = a(i);
          switch ((h ||
            (750 > $(window).width()
              ? (p = !0)
              : window.mobileCheck() && (p = !0), p && t(!1), (h = !0)), $(
            "#" + o.id
          ).attr("tabindex", "-1"), r(), o.type)) {
            case "background-chrome":
            case "background":
              i.target.mute(), o.$parentSlide.hasClass(y.currentSlide) &&
                e(o.id);
          }
          o.$parentSlide.addClass(y.loaded);
        },
        onStateChange: function(e) {
          var t = a(e);
          switch (e.data) {
            case 0:
              !(function(e) {
                switch (e.type) {
                  case "background":
                    g[e.id].seekTo(0);
                    break;
                  case "background-chrome":
                    g[e.id].seekTo(0), n(e.id);
                    break;
                  case "chrome":
                    n(e.id);
                }
              })(t);
              break;
            case 1:
              i(t);
              break;
            case 2:
              o(t);
          }
        }
      }
    },
    y = {
      playing: "video-is-playing",
      paused: "video-is-paused",
      loading: "video-is-loading",
      loaded: "video-is-loaded",
      slideshowWrapper: "slideshow-wrapper",
      slide: "slideshow__slide",
      slideBackgroundVideo: "slideshow__slide--background-video",
      slideDots: "slick-dots",
      videoChrome: "slideshow__video--chrome",
      videoBackground: "slideshow__video--background",
      playVideoBtn: "slideshow__video-control--play",
      closeVideoBtn: "slideshow__video-control--close",
      currentSlide: "slick-current",
      slickClone: "slick-cloned",
      supportsAutoplay: "autoplay",
      supportsNoAutoplay: "no-autoplay"
    };
  return {
    init: function(e) {
      if (
        e.length &&
        ((m[e.attr("id")] = {
          id: e.attr("id"),
          videoId: e.data("id"),
          type: e.data("type"),
          status: "chrome" === e.data("type") ? "closed" : "background",
          videoSelector: e.attr("id"),
          $parentSlide: e.closest("." + y.slide),
          $parentSlideshowWrapper: e.closest("." + y.slideshowWrapper),
          controls: "background" === e.data("type") ? 0 : 1,
          slideshow: e.data("slideshow")
        }), !f)
      ) {
        var t = document.createElement("script");
        t.src = "https://www.youtube.com/iframe_api";
        var i = document.getElementsByTagName("script")[0];
        i.parentNode.insertBefore(t, i);
      }
    },
    loadVideos: function() {
      for (var e in m)
        if (m.hasOwnProperty(e)) {
          var t = $.extend({}, v, m[e]);
          (t.playerVars.controls = t.controls), (g[e] = new YT.Player(e, t));
        }
      l(), (f = !0);
    },
    loadVideo: function(e) {
      if (f) {
        var t = $.extend({}, v, m[e]);
        (t.playerVars.controls = t.controls), (g[e] = new YT.Player(e, t)), l();
      }
    },
    playVideo: function(t) {
      (h || p) && (!t || "function" != typeof g[t].playVideo || e(t));
    },
    pauseVideo: function(e) {
      g[e] && "function" == typeof g[e].pauseVideo && g[e].pauseVideo();
    },
    removeEvents: function() {
      $(document).off(".videoPlayer"), $(window).off(".videoPlayer");
    }
  };
})()), (function() {
  var e = $("#BlogTagFilter");
  e.length &&
    e.on("change", function() {
      location.href = $(this).val();
    });
})(), (window.theme = theme || {}), (theme.customerTemplates = (function() {
  return {
    init: function() {
      var e;
      $("#RecoverPassword").on("click", function(e) {
        e.preventDefault(), $("#forgot-pass-tab").trigger("click");
      }), $("#HideRecoverPasswordLink").on("click", function(e) {
        e.preventDefault(), $("#login-tab").trigger("click");
      }), $(".reset-password-success").length &&
        $("#ResetSuccess").removeClass("hide"), (e = $("#AddressNewForm"))
        .length &&
        (Shopify &&
          new Shopify.CountryProvinceSelector(
            "AddressCountryNew",
            "AddressProvinceNew",
            { hideElement: "AddressProvinceContainerNew" }
          ), $(".address-country-option").each(function() {
          var e = $(this).data("form-id");
          new Shopify.CountryProvinceSelector(
            "AddressCountry_" + e,
            "AddressProvince_" + e,
            { hideElement: "AddressProvinceContainer_" + e }
          );
        }), $(".address-new-toggle").on("click", function() {
          e.toggleClass("hide");
        }), $(".address-edit-toggle").on("click", function() {
          var e = $(this).data("form-id");
          $("#EditAddress_" + e).toggleClass("hide");
        }), $(".address-delete").on("click", function() {
          var e = $(this), t = e.data("form-id"), i = e.data("confirm-message");
          confirm(i || "Are you sure you wish to delete this address?") &&
            Shopify.postLink("/account/addresses/" + t, {
              parameters: { _method: "delete" }
            });
        }));
    }
  };
})()), (window.theme = window.theme || {}), (theme.HeaderSection = function() {
  theme.Header.init(), theme.Search.init(), theme.CurrencyPicker.init();
}), (theme.Maps = (function() {
  function e(e) {
    (this.$container = $(e)), "loaded" === i
      ? this.createMap()
      : (o.push(this), "loading" != i &&
          ((i = "loading"), void 0 === window.google &&
            $.getScript(
              "https://maps.googleapis.com/maps/api/js?key=" + n
            ).then(function() {
              (i = "loaded"), $.each(o, function(e, t) {
                t.createMap();
              });
            })));
  }
  var t = 14, i = null, o = [], n = theme.mapKey ? theme.mapKey : "";
  return (e.prototype = _.assignIn({}, e.prototype, {
    createMap: function() {
      var e = this.$container.find(".map-section__container");
      return (function(e) {
        var t = $.Deferred(),
          i = new google.maps.Geocoder(),
          o = e.data("address-setting");
        return i.geocode({ address: o }, function(e, i) {
          i !== google.maps.GeocoderStatus.OK && t.reject(i), t.resolve(e);
        }), t;
      })(e)
        .then(
          function(i) {
            var o = {
              mapTypeId: "terrain",
              zoom: t,
              center: i[0].geometry.location,
              disableDefaultUI: !0
            },
              n = (this.map = new google.maps.Map(e[0], o)),
              a = (this.center = n.getCenter());
            new google.maps.Marker({ map: n, position: n.getCenter() });
            google.maps.event.addDomListener(
              window,
              "resize",
              $.debounce(250, function() {
                google.maps.event.trigger(n, "resize"), n.setCenter(a);
              })
            );
          }.bind(this)
        )
        .fail(function() {
          var t;
          (t = "ZERO_RESULTS" === status
            ? theme.strings.addressNoResults
            : "OVER_QUERY_LIMIT" === status
                ? theme.strings.addressQueryLimit
                : theme.strings
                    .addressError), e.parent().addClass("map-section--load-error").html('<div class="errors text-center">' + t + "</div>");
        });
    },
    onUnload: function() {
      google.maps.event.clearListeners(this.map, "resize");
    }
  })), e;
})()), (theme.Product = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.settings = {
      mediaQueryMediumUp: "screen and (min-width: 750px)",
      mediaQuerySmall: "screen and (max-width: 749px)",
      bpSmall: !1,
      enableHistoryState: t.data("enable-history-state") || !1,
      imageSize: null,
      namespace: ".slideshow-" + i,
      sectionId: i,
      sliderActive: !1,
      swatch_color: t.attr("data-product_swatch_color"),
      swatch_color_advanced: t.attr("data-product_swatch_color_advanced"),
      swatch_size: t.attr("data-product_swatch_size"),
      product_design: t.attr("data-product_design"),
      product_mobile_variant: t.attr("data-product_mobile_variant")
    }), (this.selectors = {
      product: "#ProductSection-" + i,
      addToCart: "#AddToCart-" + i,
      addToCartText: "#AddToCartText-" + i,
      stockText: ".stock-" + i,
      comparePrice: "#ComparePrice-" + i,
      originalPrice: "#ProductPrice-" + i,
      SKU: ".variant-sku",
      originalPriceWrapper: ".product-price__price-" + i,
      originalSelectorId: "#ProductSelect-" + i,
      productFeaturedImage: ".FeaturedImage-" + i,
      productImageWrap: "#FeaturedImageZoom-" + i,
      productPrices: ".product-single__price-" + i,
      productThumbImages: "#product-thumbnails-" + i,
      productMainImages: "#product-images-" + i,
      productPreviewMainImages: ".product-preview-images-" + i,
      saleLabel: ".product-price__sale-label-" + i,
      singleOptionSelector: ".single-option-selector-" + i,
      singleOptionSelectorId: "#single-option-selector-" + i,
      singleOptionSwatches: "tawcvs-swatches-" + i,
      instagramProduct: "#product-instagram-" + i,
      instagramProductNameSpace: "product-instagram-" + i,
      variationsSelector: "#variations-" + i,
      variationSelector: ".variation-select-" + i,
      qtyVariant: ".qty-variant-" + i,
      threedId: ".threed-id-" + i,
      countDownId: ".countdown-" + i,
      couponCode: "#coupon-code-" + i,
      couponBtn: "#coupon-btn-" + i,
      sidebarSlide: ".sidebar-slick-vertical-" + i,
      variantJson: "ProductVariantJson-"+ i
    }), 
      
      
      $("#ProductJson-" + i).html() &&
      ((this.productSingleObject = JSON.parse(
        document.getElementById("ProductJson-" + i).innerHTML
      )), (this.productSwatchSingleObject = JSON.parse(
        document.getElementById("ProductSwatchJson-" + i).innerHTML
      )),(this.productMoreSingleObject = JSON.parse($('.ProductMoreJson-' + i).html())),
       
        this._updateProductObject(),this._stringOverrides(), this._initCountDown(), this._initCoupon(), this._initPopup(), this._initVariants(), this._initSwatches(), this._initFeature(), this._initCompact(), this._initStickyImages(), this._initThumbnailsGallery(), this._initImages(), this._initSidebar(), this._initZoom(), this._initGallery(), this._initTab(), this._initQuantity(), this._initReviewTab(), this._relatedProducts(), this._recentlyViewed(), this._instagramProducts());
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
     _updateProductObject: function() {
      var self = this;
      
      $.each(self.productMoreSingleObject.variants, function(index, variant) {
        $.each(variant, function(name, value) {
          (self.productSingleObject.variants[index])[name] = value;
        });
      });
    },
    _stringOverrides: function() {
      (theme.productStrings = theme.productStrings || {}), $.extend(
        theme.strings,
        theme.productStrings
      );
    },
    _initBreakpoints: function() {
      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {},
        unmatch: function() {}
      }), enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {}
      });
    },
    _initPopup: function() {
      $(".sizechart-btn").click(function() {
        return $.magnificPopup.open({
          items: { src: "#sizechart", type: "inline" },
          tLoading: "",
          mainClass: "popup-wrapper mfp-with-zoom",
          removalDelay: 200
        }), !1;
      }), $(".return-btn").click(function() {
        return $.magnificPopup.open({
          items: { src: "#delivery-return", type: "inline" },
          tLoading: "",
          mainClass: "popup-wrapper mfp-with-zoom",
          removalDelay: 200
        }), !1;
      });
    },
    _initCoupon: function() {
      0 < $(this.selectors.couponBtn).length &&
        $(this.selectors.couponBtn).unbind("click") &&
        $(this.selectors.couponBtn).click(function() {
          var e = $("<input>");
          $("body").append(
            e
          ), e.val($(this).data("coupon")).select(), document.execCommand("copy"), e.remove(), jQuery("#rtp-message").html($(this).data("copied")), jQuery("#rt-unero-popup-message").css("margin-left", "-" + parseFloat(jQuery("#rt-unero-popup-message").width()) / 2 + "px").fadeIn(), window.setTimeout(
            function() {
              jQuery("#rt-unero-popup-message").fadeOut();
            },
            2e3
          );
        });
    },
    _initCountDown: function() {
      if (
        !(0 >= $(this.selectors.countDownId).length) &&
        $().countdown &&
        0 < $(this.selectors.countDownId).length &&
        "" != $(this.selectors.countDownId).data("countdown")
      ) {
        var e = new Date(),
          t = $(this.selectors.countDownId).data("countdown").split("-");
        e < (t = new Date(t[2], parseInt(t[0]) - 1, t[1])) &&
          $(this.selectors.countDownId).countdown({
            until: t,
            layout: '<span class="countdown-day">{dn}d</span><span class="countdown-hour">{hn}h</span><span class="countdown-minute">{mn}m</span><span class="countdown-second">{sn}s</span>'
          });
      }
    },
    _initFeature: function() {
      if (
        (0 < $(this.selectors.product + " .product-video-button a").length &&
          $(this.selectors.product + " .product-video-button a").magnificPopup({
            type: "iframe",
            mainClass: "mfp-fade",
            removalDelay: 160,
            preloader: !1,
            disableOn: !1,
            fixedContentPos: !1
          }), 0 < $(this.selectors.product + " .product-360-button a").length)
      ) {
        for (
          var e,
            t = [],
            i = JSON.parse(
              document.getElementById("threed-id-" + this.sectionId).innerHTML
            ),
            o = 1;
          72 >= o;
          o++
        )
          i[(e = "f" + o)] && t.push(i[e]);
        if (0 < t.length) {
          var n = t.length;
          $(this.selectors.threedId).ThreeSixty({
            totalFrames: n,
            endFrame: n,
            currentFrame: 1,
            imgList: ".threed-view-images",
            progress: ".spinner",
            imgArray: t,
            height: null,
            width: null,
            responsive: !0,
            navigation: !0,
            onReady: function() {
              $(".product-360-button a").magnificPopup({
                type: "inline",
                mainClass: "mfp-fade",
                removalDelay: 160,
                disableOn: !1,
                preloader: !1,
                fixedContentPos: !1,
                callbacks: {
                  open: function() {
                    $(window).resize();
                  }
                }
              });
            }
          });
        }
      }
    },
    _initCompact: function() {
      if (0 < $(".product-accordion").length) {
        var e = $(".product-accordion"), t = $(".accordion-item");
        t.each(function() {
          var e = $(this),
            t = e.find(".title"),
            i = t.innerHeight(),
            o = e.find(".content").outerHeight();
          t.parent(".accordion-item");
          t.data("height", i), e.data("height", i + o);
        }), t.each(function() {
          var e = $(this),
            t = e.find(".title"),
            i = t.innerHeight(),
            o = e.find(".content").outerHeight(),
            n = t.parent(".accordion-item");
          t.data(
            "height",
            i
          ), e.data("height", i + o), n.hasClass("active") && n.height(n.data("height"));
        }), e.on("click", ".accordion-item > .title", function() {
          var e = $(this), i = e.parent(".accordion-item");
          i.hasClass("active") ||
            t
              .closest(".active")
              .removeClass("active")
              .height(
                e.data("height")
              ), i.toggleClass("active"), i.hasClass("active") ? i.height(i.data("height")) : i.height(e.data("height"));
        });
      }
    },
    
    _initStickyImages: function() {
      if( ! $('body').hasClass('unero-product-design-sticky') ) return;
      var details = $('.product-summary'),
          detailsInner = details.find('.entry-summary'),
          detailsWidth = details.width(),
          images = $('.unero-images'),
          thumbnails = images.find('.shopify-product-gallery__wrapper a'),
          offsetThumbnails,
          viewportHeight = $(window).height(),
          imagesHeight = images.outerHeight(),
          topOffset = 50,
          maxWidth = 600,
          innerWidth,
          detailsHeight = details.outerHeight(),
          scrollTop = $(window).scrollTop(),
          imagesTop =  images.offset().top,
          detailsLeft =  details.offset().left + 15,
          imagesBottom = imagesTop + imagesHeight,
          detailsBottom = scrollTop + topOffset + detailsHeight;


      details.css({
        height: detailsHeight
      });

      $(window).resize(function() {
        recalculate();
      });

      $(window).scroll(function() {
        onscroll();
        animateThumbnails();
      });

      images.imagesLoaded(function() {
        recalculate();
      });
      function animateThumbnails() {
        viewportHeight = $(window).height();
        thumbnails.each(function(){
          offsetThumbnails = $(this).offset().top;
          if(scrollTop > (offsetThumbnails - viewportHeight + 20)) {
            $(this).addClass('animate-images');
          }

        });
      }

      function onscroll() {
        scrollTop = $(window).scrollTop();
        detailsBottom = scrollTop + topOffset + detailsHeight;
        detailsWidth = details.width();
        detailsLeft =  details.offset().left + 15;
        imagesTop =  images.offset().top;
        imagesBottom = imagesTop + imagesHeight;

        if (detailsWidth > maxWidth) {
          innerWidth = (detailsWidth - maxWidth) / 2;
          detailsLeft = detailsLeft + innerWidth;
        }

        // Fix after scroll the header
        if( scrollTop + topOffset >= imagesTop ) {
          details.addClass('block-sticked');

          detailsInner.css({
            top: topOffset,
            left: detailsLeft,
            width: detailsWidth,
            position: 'fixed',
            transform:'translateY(-20px)'
          });
        } else {
          details.removeClass('block-sticked');
          detailsInner.css({
            top: 'auto',
            left: 'auto',
            width: 'auto',
            position: 'relative',
            transform:'translateY(0px)'
          });
        }
        // When rich the bottom line
        if( detailsBottom > (imagesBottom + 50)) {
          details.addClass('hide-temporary');
        } else {
          details.removeClass('hide-temporary');
        }
      };


      function recalculate() {
        viewportHeight = $(window).height();
        detailsHeight = details.outerHeight();
        imagesHeight = images.outerHeight();

        // If enought space in the viewport
        if( detailsHeight < ( viewportHeight - topOffset ) ) {
          details.addClass('in-viewport').removeClass('not-in-viewport');
        } else {
          details.removeClass('in-viewport').addClass('not-in-viewport');
        }
        onscroll();
        animateThumbnails();
      };

    },
    _initStickyImages1: function() {
      function e() {
        (l = $(window).height()), c.each(function() {
          (o = $(this).offset()
            .top), f > o - l + 20 && $(this).addClass("animate-images");
        });
      }
      function t() {
        (f = $(window).scrollTop()), (y = f + u + p), (s = n.width()), (g =
          n.offset().left + 15), (m = r.offset().top), (v = m + d), s > h &&
          (g += (s - h) / 2), f + u >= m
          ? (n.addClass("block-sticked"), a.css({
              top: u,
              left: g,
              width: s,
              position: "fixed",
              transform: "translateY(-20px)"
            }))
          : (n.removeClass("block-sticked"), a.css({
              top: "auto",
              left: "auto",
              width: "auto",
              position: "relative",
              transform: "translateY(0px)"
            })), y > v + 50
          ? n.addClass("hide-temporary")
          : n.removeClass("hide-temporary");
      }
      function i() {
        (l = $(
          window
        ).height()), (p = n.outerHeight()), (d = r.outerHeight()), p < l - u
          ? n.addClass("in-viewport").removeClass("not-in-viewport")
          : n.removeClass("in-viewport").addClass("not-in-viewport"), t(), e();
      }
      if ($("body").hasClass("unero-product-design-sticky")) {
        var o,
          n = $(".product-summary"),
          a = n.find(".entry-summary"),
          s = n.width(),
          r = $(".unero-images"),
          c = r.find(".shopify-product-gallery__wrapper a"),
          l = $(window).height(),
          d = r.outerHeight(),
          u = 130,
          h = 600,
          p = n.outerHeight(),
          f = $(window).scrollTop(),
          m = r.offset().top,
          g = n.offset().left + 15,
          v = m + d,
          y = f + u + p;
        n.css({ height: p }), $(window).resize(function() {
          i();
        }), $(window).scroll(function() {
          t(), e();
        }), r.imagesLoaded(function() {
          i();
        });
      }
    },
    _initThumbnailsGallery: function() {
      var e = $(this.selectors.productMainImages);
      "gallery" == this.settings.product_design &&
        $(".thumbnail-gallery-item").on("click", function() {
          var t = $(this);
          t.hasClass("active") ||
            ($(".thumbnail-gallery-item").removeClass("active"), t.addClass(
              "active"
            ), $(".thumbnail-gallery-item").each(function(i) {
              $(this).attr("id") != t.attr("id") || e.slick("slickGoTo", i, !0);
            }));
        });
    },
    _instagramProducts: function() {
      if (0 < $(this.selectors.instagramProduct).length) {
        var e = $(this.selectors.instagramProduct),
          t = this.selectors.instagramProductNameSpace,
          i = e.attr("data-id"),
          o = e.attr("data-token"),
          n = e.attr("data-limit"),
          a = e.data("per_view"),
          s = e.data("auto"),
          r = !1,
          c = e.data("speed");
        new Instafeed({
          get: "user",
          target: t,
          accessToken: o,
          userId: parseInt(i),
          limit: parseInt(n),
          resolution: "standard_resolution",
          resolution2: "standard_resolution",
          template: '<li class="product"><a class="insta-item" target="_blank" href="{{link}}" style="background-image:url({{image}});"><i class="social_instagram"></i></a></li>',
          after: function() {
            0 < s ? ((r = !0), (s = !0)) : (s = !1), e
              .not(".slick-initialized")
              .slick({
                slidesToShow: a,
                slidesToScroll: 1,
                autoplaySpeed: c,
                autoplay: s,
                infinite: r,
                dots: !1,
                prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
                nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>',
                responsive: [
                  {
                    breakpoint: 1200,
                    settings: { slidesToShow: 4, slidesToScroll: 1 }
                  },
                  {
                    breakpoint: 767,
                    settings: { slidesToShow: 3, slidesToScroll: 1 }
                  }
                ]
              });
          }
        }).run();
      }
    },
    _relatedProducts: function() {
      var e = $(this.selectors.product + " .related.products ul.products");
      0 < e.length &&
        e
          .not(".slick-initialized")
          .slick({
            slidesToShow: e.data("per_view"),
            slidesToScroll: e.data("per_view"),
            arrows: !1,
            lazyLoad: "ondemand",
            dots: !0,
            responsive: [
              {
                breakpoint: 1200,
                settings: { slidesToShow: 3, slidesToScroll: 1 }
              },
              {
                breakpoint: 767,
                settings: { slidesToShow: 2, slidesToScroll: 1 }
              }
            ]
          });
    },
    _recentlyViewed: function() {
      var e = $(this.selectors.product + " .viewed.products ul.products"),
        t = Currency.cookie.rtread("rt-recent"),
        i = $(".template-product .viewed.products").data("handle"),
        o = $(".template-product .viewed.products").data("id");
      if (null != t) {
        if (
          (1 < (t = (t = t.split(",")).reverse()).length
            ? $("#recently-viewed-products").show()
            : t != i && $("#recently-viewed-products").show(), $.ajax({
            url: "/search?view=viewed&q=" + t + "_sp_" + o,
            dataType: "html",
            type: "GET",
            success: function(e) {
              $("#recently_wrap").html(e);
            },
            error: function() {
              console.log("ajax error");
            },
            complete: function() {
              theme.roarApplication.initLoadMore(), theme.CurrencyPicker.convert(
                ".viewed.products .money"
              ), 0 < e.length &&
                e
                  .not(".slick-initialized")
                  .slick({
                    slidesToShow: e.data("per_view"),
                    slidesToScroll: e.data("per_view"),
                    arrows: !1,
                    lazyLoad: "ondemand",
                    dots: !0,
                    responsive: [
                      {
                        breakpoint: 1200,
                        settings: { slidesToShow: 3, slidesToScroll: 1 }
                      },
                      {
                        breakpoint: 767,
                        settings: { slidesToShow: 2, slidesToScroll: 1 }
                      }
                    ]
                  }), $(".viewed.products").find("img.lazy").lazyload();
            }
          }), 0 > t.indexOf(i))
        ) {
          t.length >= theme.viewed_limit && t.pop(), t.push(i);
          try {
            t = t.join(",");
          } catch (e) {}
        }
      } else t = i;
      Currency.cookie.rtwrite("rt-recent", t);
    },
    _initReviewTab: function() {
      $(".rt-unero-product-rating").unbind("click"), $(
        ".rt-unero-product-rating"
      ).click(function() {
        0 < $('a[href="#tab-reviews"]').length &&
          $('a[href="#tab-reviews"]').trigger(
            "click"
          ), $("html,body").animate({ scrollTop: $("#tab-reviews").offset().top }, "slow");
      });
    },
    _initQuantity: function() {
      var e = $(this.selectors.addToCart), t = $(this.selectors.qtyVariant);
      $(".q_up").unbind("click"), $(".q_up").click(function() {
        var i = $(this).data("product_id"),
          o = parseInt($(".qty-" + i).val()) + 1;
        if (($(".qty-" + i).val(o), 0 < t.length)) {
          var n = !1;
          t.each(function() {
            var e = parseInt($(this).val()), t = $(this).data("variant_id");
            0 == e
              ? !$("form#cart-variant-form-" + t).hasClass("not-submit") &&
                  $("form.variant-form-" + i).addClass("not-submit")
              : ((n = !0), $("form#cart-variant-form-" + t).removeClass(
                  "not-submit"
                ));
          }), n
            ? e.removeClass("disabled")
            : !e.hasClass("disabled") && e.addClass("disabled");
        }
      }), $(".q_down").unbind("click"), $(".q_down").click(function() {
        var i = $(this).data("product_id"), o = parseInt($(".qty-" + i).val());
        if (0 < t.length) {
          0 < o && $(".qty-" + i).val(o - 1);
          var n = !1;
          t.each(function() {
            var e = parseInt($(this).val()), t = $(this).data("variant_id");
            0 == e
              ? !$("form#cart-variant-form-" + t).hasClass("not-submit") &&
                  $("form.variant-form-" + i).addClass("not-submit")
              : ((n = !0), $("form#cart-variant-form-" + t).removeClass(
                  "not-submit"
                ));
          }), n
            ? e.removeClass("disabled")
            : !e.hasClass("disabled") && e.addClass("disabled");
        } else 1 < o && $(".qty-" + i).val(o - 1);
      });
    },
    _initTab: function() {
      $(this.selectors.product + " .product-tabs")
        .off("click")
        .on("click", "ul.tabs li a", function(e) {
          if ((e.preventDefault(), $(this).parent("li").hasClass("active")))
            return !1;
          var t = $(this), i = t.closest(".product-tabs");
          return i
            .find("ul.tabs")
            .find("li")
            .removeClass(
              "active"
            ), $(this).parent("li").addClass("active"), i.find(".panel:visible").fadeOut(300, function() {
            i.find(t.attr("href")).fadeIn(300);
          }), !1;
        });
    },
    _initGallery: function() {
      !(function(e) {
        for (
          var t = function(e) {
            (e = e || window.event).preventDefault
              ? e.preventDefault()
              : (e.returnValue = !1);
            var t = (function e(t, i) {
              return t && (i(t) ? t : e(t.parentNode, i));
            })(e.target || e.srcElement, function(e) {
              return (t =
                "photoswipe-item"), -1 < (" " + e.className + " ").indexOf(" " + t + " ");
              var t;
            });
            if (t) {
              for (
                var o,
                  n = t.closest(".photoswipe-wrapper"),
                  a = $(t.closest(".photoswipe-wrapper"))
                    .find(".photoswipe-item")
                    .get(),
                  s = a.length,
                  r = 0,
                  c = 0;
                c < s;
                c++
              )
                if (1 === a[c].nodeType) {
                  if (a[c] === t) {
                    o = r;
                    break;
                  }
                  r++;
                }
              return 0 <= o && i(o, n), !1;
            }
          },
            i = function(e, t, i, o) {
              var n, a, s, r = document.querySelectorAll(".pswp")[0];
              if (
                ((s = (function(e) {
                  for (
                    var t,
                      i,
                      o,
                      n,
                      a = $(e).find(".photoswipe-item").get(),
                      s = a.length,
                      r = [],
                      c = 0;
                    c < s;
                    c++
                  )
                    if (1 === (t = a[c]).nodeType)
                      if (
                        ((o = (i = t.children[0])
                          .getAttribute("data-size")
                          .split("x")), "video" == $(i).data("type"))
                      ) {
                        var l = $($(i).data("id")).html();
                        r.push({ html: l });
                      } else
                        (n = {
                          src: i.getAttribute("href"),
                          w: parseInt(o[0], 10),
                          h: parseInt(o[1], 10)
                        }), 1 < t.children.length &&
                          (n.title = $(t).find(".caption").html()), 0 <
                          i.children.length &&
                          (n.msrc = i.children[0].getAttribute(
                            "src"
                          )), (n.el = t), r.push(n);
                  return r;
                })(t)), (a = {
                  closeOnScroll: !1,
                  galleryUID: t.getAttribute("data-pswp-uid")
                }), o)
              )
                if (a.galleryPIDs) {
                  for (var c = 0; c < s.length; c++)
                    if (s[c].pid == e) {
                      a.index = c;
                      break;
                    }
                } else a.index = parseInt(e, 10) - 1;
              else a.index = parseInt(e, 10);
              isNaN(a.index) ||
                (i && (a.showAnimationDuration = 0), (n = new PhotoSwipe(
                  r,
                  PhotoSwipeUI_Default,
                  s,
                  a
                )).init(), n.listen("beforeChange", function() {
                  var e = $(n.currItem.container);
                  $(".pswp__video").removeClass(
                    "active"
                  ), e.find(".pswp__video").addClass("active"), $(
                    ".pswp__video"
                  ).each(function() {
                    $(this).hasClass("active") ||
                      $(this).attr("src", $(this).attr("src"));
                  });
                }), n.listen("close", function() {
                  $(".pswp__video").each(function() {
                    $(this).attr("src", $(this).attr("src"));
                  });
                }));
            },
            o = document.querySelectorAll(e),
            n = 0,
            a = o.length;
          n < a;
          n++
        )
          o[n].setAttribute("data-pswp-uid", n + 1), (o[n].onclick = t);
        var s = (function() {
          var e = window.location.hash.substring(1), t = {};
          if (5 > e.length) return t;
          for (var i = e.split("&"), o = 0; o < i.length; o++)
            if (i[o]) {
              var n = i[o].split("=");
              2 > n.length || (t[n[0]] = n[1]);
            }
          return t.gid && (t.gid = parseInt(t.gid, 10)), t;
        })();
        s.pid && s.gid && i(s.pid, o[s.gid - 1], !0, !0);
      })(this.selectors.product + " .photoswipe-wrapper");
    },
    _initZoom: function() {
      if ($(".easyzoom").length)
        if (1024 < $(window).width())
          $(".easyzoom:not(.feature-video)")
            .easyZoom({ loadingNotice: "", errorNotice: "", preventClicks: !1 })
            .data("easyZoom");
        else
          $(".easyzoom a").click(function(e) {
            e.preventDefault();
          });
    },
    _initImages: function() {
      var e = this, t = $(e.selectors.productMainImages);
      if (
        "left" != this.settings.product_design &&
        "bottom" != this.settings.product_design &&
        "sidebar" != this.settings.product_design &&
        "full-screen" != this.settings.product_design
      )
        "carousel" == this.settings.product_design
          ? t
              .not(".slick-initialized")
              .slick({
                centerMode: !0,
                centerPadding: "500px",
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
                nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>',
                responsive: [
                  {
                    breakpoint: 1680,
                    settings: {
                      centerMode: !0,
                      centerPadding: "400px",
                      slidesToShow: 1
                    }
                  },
                  {
                    breakpoint: 1440,
                    settings: {
                      centerMode: !0,
                      centerPadding: "350px",
                      slidesToShow: 1
                    }
                  },
                  {
                    breakpoint: 1200,
                    settings: {
                      centerMode: !0,
                      centerPadding: "300px",
                      slidesToShow: 1
                    }
                  },
                  {
                    breakpoint: 1024,
                    settings: {
                      arrows: !1,
                      centerMode: !0,
                      centerPadding: "250px",
                      slidesToShow: 1
                    }
                  },
                  {
                    breakpoint: 992,
                    settings: {
                      centerMode: !0,
                      centerPadding: "200px",
                      slidesToShow: 1
                    }
                  },
                  {
                    breakpoint: 768,
                    settings: {
                      arrows: !1,
                      centerMode: !0,
                      centerPadding: "125px",
                      slidesToShow: 1
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      arrows: !1,
                      centerMode: !0,
                      centerPadding: "50px",
                      slidesToShow: 1
                    }
                  }
                ]
              })
          : t
              .not(".slick-initialized")
              .slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: !1,
                asNavFor: i,
                prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
                nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>'
              });
      else if (0 < $(e.selectors.productThumbImages).length) {
        var i = $(e.selectors.productThumbImages).find(".thumbnails");
        t
          .not(".slick-initialized")
          .slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: !1,
            asNavFor: i,
            prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
            nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>'
          });
        var o = "0" != $(e.selectors.productThumbImages).data("vertical");
        i
          .not(".slick-initialized")
          .slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            asNavFor: t,
            focusOnSelect: !0,
            vertical: o,
            infinite: !1,
            prevArrow: '<span class="icon-chevron-up slick-prev-arrow"></span>',
            nextArrow: '<span class="icon-chevron-down slick-next-arrow"></span>'
          });
      }
      t.imagesLoaded(function() {
        t.addClass("loaded");
      });
    },
    _initSidebar: function() {
      ($sidebarSlide = $(this.selectors.sidebarSlide)), 0 <
        $sidebarSlide.length &&
        $sidebarSlide.each(function() {
          var e = $(this), t = $(this).data("per_view");
          $(this)
            .not(".slick-initialized")
            .slick({
              slidesToShow: t,
              slidesToScroll: 1,
              vertical: !0,
              focusOnSelect: !0,
              infinite: !1,
              prevArrow: '<span class="icon-chevron-up slick-prev-arrow"></span>',
              nextArrow: '<span class="icon-chevron-down slick-next-arrow"></span>'
            }), e.imagesLoaded(function() {
            e.addClass("loaded");
          });
        });
    },
    _initForceHeight: function() {
      0 < $(this.selectors.productPreviewMainImages).length &&
        $(this.selectors.productPreviewMainImages)
          .not(".slick-initialized")
          .slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: !1,
            prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
            nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>'
          });
    },
    _initSwatches: function() {
      function e(e) {
        let t = e
          .replace("https:", "")
          .replace("http:", "")
          .split("?v=")[0]
          .split("/"),
          i = t[t.length - 1].split("."),
          o = i.pop(),
          n = i.join(".") + "_100x." + o;
        return e.replace(t[t.length - 1], n);
      }
      var t = this.selectors.singleOptionSelectorId,
        o = this.productSingleObject,
        n = this.productSwatchSingleObject,
        a = [];
      if (
        ("1" == this.settings.swatch_size && a.push("Size"), a.push(
          "size"
        ), "1" == this.settings.swatch_color &&
          (a.push("Color"), a.push("Colour"), a.push("color"), a.push(
            "colour"
          )), 0 < a.length)
      ) {
        var s = !1,
          r = 0,
          c = theme.asset_url.substring(0, theme.asset_url.lastIndexOf("?")),
          l = theme.asset_url.substring(
            theme.asset_url.lastIndexOf("?"),
            theme.asset_url.length
          );
        for (i = 0; i < o.options.length; i++) {
          var d = "",
            u = "",
            h = "",
            p = "",
            f = "",
            m = "",
            g = "",
            v = "",
            y = "";
          if (
            ((d = "object" == typeof o.options[i]
              ? o.options[i].name
              : o.options[i]), (s = !1), !1, -1 < a.indexOf(d))
          ) {
            (s = !0), (r = i);
            var w = d.toLowerCase();
            if ((/color|colour/i.test(w) && !0, s)) {
              var _ = [];
              for (j = 0; j < o.variants.length; j++) {
                var b = o.variants[j],
                  C = this.htmlEntities(b.options[r]),
                  k = this.convertToSlug(C);
                0 > _.indexOf(C) &&
                  ((y = "color" != w && "colour" != w
                    ? "swatch-label "
                    : ""), (m = $(
                    this.selectors.singleOptionSelectorId + "-" + r
                  ).val() == C
                    ? "selected "
                    : ""), "color" != w && "colour" != w
                    ? (v =
                        "background-color:" +
                        C +
                        "; background-image: url(" +
                        c +
                        k +
                        ".png" +
                        l +
                        ")")
                    : "1" == this.settings.swatch_color_advanced
                        ? ((g = "advanced"), (v = null !== n[k] &&
                            void 0 !== n[k] &&
                            "" != n[k]
                            ? "background-image: url(" +
                                c +
                                n[k] +
                                ".png" +
                                l +
                                ")"
                            : null === b.featured_image
                                ? "background-color:" +
                                    C +
                                    "; background-image: url(" +
                                    c +
                                    k +
                                    ".png" +
                                    l +
                                    ")"
                                : "background-image: url(" +
                                    e(b.featured_image.src) +
                                    ")"))
                        : ((g = ""), (v =
                            "background-color:" +
                            C +
                            "; background-image: url(" +
                            c +
                            k +
                            ".png" +
                            l +
                            ")")), (h =
                    h +
                    '<span id="swatch-' +
                    r +
                    "-" +
                    k +
                    '" data-id="' +
                    this.selectors.singleOptionSelectorId +
                    "-" +
                    r +
                    '" data-original-title="' +
                    C +
                    '" class="available ' +
                    m +
                    "swatch " +
                    g +
                    " " +
                    y +
                    " swatch-" +
                    w +
                    " swatch-" +
                    C +
                    '" title="' +
                    C +
                    '" data-value="' +
                    C +
                    '" data-poption="' +
                    r +
                    '" style="' +
                    v +
                    '">' +
                    C +
                    "<span class='soldout-image'></span><span class='unero-tooltip '><span class='unero-tooltip-label'>" +
                    C +
                    "</span></span></span>"), _.push(C));
              }
              (u =
                '<div class="' +
                this.selectors.singleOptionSwatches +
                ' tawcvs-swatches" data-attribute_name="attribute_pa_' +
                w +
                '">' +
                h +
                "</div>"), (p = $(
                this.selectors.singleOptionSelectorId + "-" + r
              )), (f = $(this.selectors.variationSelector + "-" + r)), "" !=
                u && (p.after(u), p.hide(), f.addClass("hide-choose-option"));
            }
          }
        }
      }
      var S = "";
      0 < $("." + this.selectors.singleOptionSwatches).length &&
        ((S = $("." + this.selectors.singleOptionSwatches + " > span")).unbind(
          "click"
        ), S.on("click", function() {
          var e = $(this).data("id"),
            n = $(this).data("poption"),
            a = $(this).data("value");
          $(this).data("value") != $(e).val() &&
            ($(e).val($(this).data("value")).trigger("change"), $(e)
              .closest("td")
              .find("span.swatch")
              .removeClass("selected"), $(this).addClass(
              "selected"
            )), (function(e, o, n) {
            for (i = 0; i < e.options.length; i++) i != o &&
                $(t + "-" + i + " option").each(function() {
                  var t = "unavailable", a = $(this).attr("value");
                  for (j = 0; j < e.variants.length; j++) {
                    var s = e.variants[j];
                    if (s.options[o] == n && s.options[i] == a) {
                      t = 1 == s.available ? "available" : "sold_out";
                      break;
                    }
                  }
                  var r =
                    "#swatch-" +
                    i +
                    "-" +
                    a
                      .toLowerCase()
                      .replace(/[^a-z0-9 -]/g, "")
                      .replace(/\s+/g, "-")
                      .replace(/-+/g, "-");
                  $(r)
                    .removeClass("available")
                    .removeClass("sold_out")
                    .removeClass("unavailable")
                    .addClass(t);
                });
          })(o, n, a);
        })), $(".swatch.selected").trigger("click");
    },
    htmlEntities: function(e) {
      return (e + "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    },
    convertToSlug: function(e) {
      e = e.toLowerCase();
      for (
        var t = ['"', "'", "\\", "(", ")", "[", "]"], i = 0;
        i < t.length;
        ++i
      )
        e = e.replace(t[i], "");
      return "-" == (e = e.replace(/\W+/g, "-")).charAt(e.length - 1) &&
        (e = e.replace(/-+\z/, "")), "-" == e.charAt(0) &&
        (e = e.replace(/\A-+/, "")), e;
    },
    convertToSlug1: function(e) {
      return e
        .replace("/", "-")
        .toLowerCase()
        .replace(/[^a-z0-9 -]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-");
    },
    _initVariants: function() {
      var e = {
        $container: this.$container,
        enableHistoryState: this.$container.data("enable-history-state") || !1,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };
      (this.variants = new slate.Variants(e)), this.$container.on(
        "variantChange" + this.settings.namespace,
        this._updateAddToCart.bind(this)
      ), this.$container.on(
        "variantImageChange" + this.settings.namespace,
        this._updateImages.bind(this)
      ), this.$container.on(
        "variantPriceChange" + this.settings.namespace,
        this._updatePrice.bind(this)
      ), this.$container.on(
        "variantSKUChange" + this.settings.namespace,
        this._updateSKU.bind(this)
      );
    },
    
    
    _updateAddToCart1: function(evt) {
      var variant = evt.variant;

      if (variant) {
        
        $(this.selectors.productPrices).removeClass('visibility-hidden');
		
        if (variant.available) {
          $(this.selectors.addToCart, this.selectors.container).prop('disabled', false);
          $(this.selectors.productQuantity, this.selectors.container).removeClass('hide');
          if (variant.inventory_quantity <= 0 && variant.inventory_management == 'shopify') {
            $(this.selectors.addToCartText, this.selectors.container).text(theme.strings.preOrder);
          }
          else {
            $(this.selectors.addToCartText, this.selectors.container).text(theme.strings.addToCart);
          }
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          $(this.selectors.addToCart, this.selectors.container).prop('disabled', true);
          $(this.selectors.productQuantity, this.selectors.container).addClass('hide');
          $(this.selectors.addToCartText, this.selectors.container).text(theme.strings.soldOut);
        }
      } else {
        $(this.selectors.productQuantity, this.selectors.container).addClass('hide');
        $(this.selectors.addToCart, this.selectors.container).prop('disabled', true);
        $(this.selectors.addToCartText, this.selectors.container).text(theme.strings.unavailable);
        $(this.selectors.productPrices).addClass('visibility-hidden');
      }
    },
    
    
    _updateAddToCart: function(e) {
      
      var t = e.variant;
      var stock = "";
      if(t){
        if($(this.selectors.variantJson).data('' + t.id +'') != undefined) {
			stock = $(this.selectors.variantJson).data('' + t.id +'');
        }
	  }
      
      t
        ? ($(this.selectors.productPrices)
            .removeClass("invisible")
            .attr("aria-hidden", "true"), 
           
           t.available
            ? (
        
        		$(".variations_button").removeClass("hide"), $(
                this.selectors.addToCart
              )
                .prop("disabled", !1)
                .toggleClass("hide", !1), 
                (  (t.inventory_quantity <= 0 && t.inventory_management == 'shopify') ?
                 $(this.selectors.addToCartText).text(theme.strings.preOrder) 
                 :  $(this.selectors.addToCartText).text(theme.strings.addToCart)
                ), 
        
        	(stock != "" && ($(this.selectors.stockText).html(stock).removeClass("out-of-stock").addClass("in-stock"))))
           
           
            : ($(".variations_button").addClass("hide"), $(
                this.selectors.addToCart
              )
                .prop("disabled", !0)
                .toggleClass("hide", !0), $(this.selectors.addToCartText).text(
                theme.strings.soldOut
              ), $(this.selectors.stockText)
                .html(
                  theme.strings.available +
                    "<span>" +
                    theme.strings.outStock +
                    "</span>"
                )
                .removeClass("in-stock")
                .addClass("out-of-stock")))
           
           
        : ($(".variations_button").addClass("hide"), $(this.selectors.addToCart)
            .prop("disabled", !0)
            .toggleClass("hide", !0), $(this.selectors.addToCartText).text(
            theme.strings.unavailable
          ), $(this.selectors.stockText)
            .html("<span>" + theme.strings.unavailable + "</span>")
            .removeClass("in-stock")
            .addClass("out-of-stock"), $(this.selectors.productPrices)
            .addClass("invisible")
            .attr("aria-hidden", "false"));
    },
    _updateImages: function(e) {
      var t = e.variant,
        i = this,
        o = this.settings.product_design,
        n = t.featured_image.src
          .replace("https:", "")
          .replace("http:", "")
          .split("?v=")[0];
      $(this.selectors.productFeaturedImage).each(function() {
        var e = $(this);
        if (
          0 <= e.attr("href").indexOf(n) &&
          !e.closest(".slick-slide").hasClass("slick-cloned")
        ) {
          var t = $(i.selectors.productMainImages),
            a = e.closest(".slick-slide").attr("data-slick-index");
          if (
            ("carousel" == o
              ? t.slick("slickGoTo", a)
              : t.slick("slickGoTo", a, !0), "scroll" == o)
          ) {
            var s =
              parseInt(
                e.closest(".shopify-product-gallery__image").offset().top
              ) - 50;
            $("html,body").animate({ scrollTop: s }, "slow");
          }
          "gallery" == o &&
            0 < $(".thumbnails .thumbnail-gallery-item").length &&
            $(".thumbnails .thumbnail-gallery-item").each(function() {
              0 <= $(this).data("href").indexOf(n) && $(this).trigger("click");
            });
        } else;
      });
    },
    _updatePrice: function(e) {
      var t = e.variant;
      if (
        ($(this.selectors.originalPrice).html(
          '<span class="money">' +
            theme.Currency.formatMoney(t.price, theme.moneyFormat) +
            "</span>"
        ), t.compare_at_price > t.price)
      ) {
        if (
          ($(this.selectors.productPrices).addClass("has-sale"), $(
            this.selectors.productPrices
          ).removeClass("not-sale"), $(this.selectors.comparePrice)
            .html(
              '<span class="money">' +
                theme.Currency.formatMoney(
                  t.compare_at_price,
                  theme.moneyFormat
                ) +
                "</span>"
            )
            .removeClass("hide"), $(this.selectors.saleLabel)
            .find("span")
            .text(theme.strings.sale), "" != theme.sale_percentages)
        ) {
          var i = Math.round(
            100 * (t.compare_at_price - t.price) / t.compare_at_price
          );
          $(this.selectors.saleLabel).find("span").text("-" + i + "%");
        }
        $(this.selectors.saleLabel).addClass("hide");
      } else
        $(this.selectors.productPrices).removeClass("has-sale"), $(
          this.selectors.productPrices
        ).addClass("not-sale"), $(this.selectors.comparePrice).addClass(
          "hide"
        ), $(this.selectors.saleLabel).addClass("hide");
      theme.CurrencyPicker.convert(this.selectors.product + " .money");
    },
    _updateSKU: function(e) {
      var t = e.variant;
      "" == t.sku
        ? $(this.selectors.SKU).addClass("hide")
        : $(this.selectors.SKU).removeClass("hide").find(".sku").text(t.sku);
    },
    onUnload: function() {
      this.$container.off(this.settings.namespace);
    }
  })), e;
})()), (theme.Cart = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.cartId = $("#shopify-section-" + i)), (this.cart = $(
      "#cart-" + i
    )), (this.cartNamespace = "#cart-" + i), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {
      Shopify.Cart.ShippingCalculator.show({
        submitButton: theme.strings.shippingCalcSubmitButton,
        submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
        customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
        moneyFormat: theme.strings.shippingCalcMoneyFormat
      }), this._initQuantity();
    },
    _initQuantity: function() {
      $(".q_up").unbind("click"), $(".q_up").click(function() {
        var e = $(this).data("product_id"),
          t = parseInt($(".qty-" + e).val()) + 1;
        $(".qty-" + e).val(t);
      }), $(".q_down").unbind("click"), $(".q_down").click(function() {
        var e = $(this).data("product_id"), t = parseInt($(".qty-" + e).val());
        1 < t && $(".qty-" + e).val(t - 1);
      });
    },
    onUnload: function() {
      this.$container.off(this.cartNamespace);
    }
  })), e;
})()), (theme.SearchTemplate = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.SearchId = $("#search-" + i)), (this.Search = $(
      "#search-" + i
    )), (this.SearchNamspace =
      "#search-" + i), (this.collection_infinite_scoll = this.Search.data(
      "collection_infinite_scoll"
    )), (this.collection_infinite_scoll_auto = this.Search.data(
      "collection_infinite_scoll_auto"
    )), (this.pInfScrLoading = !1), (this.pInfScrMore = !0), (this.flagScroll = !0), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {
      this._initCollectionControl();
    },
    _initCollectionControl: function() {
      var e = this;
      "1" == this.collection_infinite_scoll &&
        ("1" == this.collection_infinite_scoll_auto &&
          $(window).scroll(function() {
            var t = $(".load_more");
            if (0 < t.length) {
              var i = $(window),
                o = i.scrollTop(),
                n = o + i.height(),
                a = t.offset().top;
              a + t.height() <= n &&
                a >= o &&
                e.flagScroll &&
                ((e.flagScroll = !1), t.find("a").trigger("click"));
            }
          }), jQuery(".load_more a").click(function(t) {
          return e._pInfScrExecute(), t.stopPropagation(), !1;
        }));
    },
    _pInfScrExecute: function() {
      var e = this,
        t = $(".load_more").last(),
        i = $(".load_more a").last().attr("href");
      0 < t.length &&
        e.pInfScrMore &&
        $.ajax({
          type: "GET",
          url: i,
          beforeSend: function() {
            jQuery(".load_more").hide(), jQuery("#un-products-loading")
              .toggleClass("hide")
              .fadeIn();
          },
          success: function(t) {
            var i = jQuery(t).find(".products .product");
            if (
              (jQuery(".products").append(i), jQuery("#un-products-loading")
                .toggleClass("hide")
                .fadeOut(), $(document.body)
                .find("img.lazy")
                .lazyload(), jQuery(t).find(".load_more a").length)
            ) {
              jQuery(".load_more a")
                .last()
                .attr(
                  "href",
                  jQuery(t).find(".load_more a").last().attr("href")
                ), jQuery(".load_more").show(), (e.flagScroll = !0);
              var o = parseInt(
                jQuery(t).find(".load_more a").last().data("page")
              );
              if (0 < o) {
                var n = o * parseInt($(".page-num-offset").data("page_size"));
                parseInt($(".page-num-offset").data("total_result")) > n &&
                  $(".result-offset").html(n).css("padding-right", "5px");
              } else
                $(".page-num-offset").html(
                  $(".page-num-offset").data("total_result")
                );
            } else
              (e.pInfScrMore = !1), jQuery(".load_more").remove(), $(
                ".page-num-offset"
              ).html($(".page-num-offset").data("total_result"));
            e._initReviews(), e._initCountDown(), $(
              '[data-toggle="tooltip"]'
            ).tooltip(), theme.CurrencyPicker.convert(
              ".un-shop-content .money"
            );
          },
          dataType: "html"
        });
    },
    _initCountDown: function() {
      $().countdown &&
        0 < $(".countdown-item:not(.is-countdown)").length &&
        $(".countdown-item:not(.is-countdown)").each(function() {
          if ("" != $(this).data("countdown")) {
            var e = new Date(), t = $(this).data("countdown").split("-");
            e < (t = new Date(t[2], parseInt(t[0]) - 1, t[1])) &&
              $(this).countdown({
                until: t,
                layout: '<span class="countdown-day">{dn}d</span><span class="countdown-hour">{hn}h</span><span class="countdown-minute">{mn}m</span><span class="countdown-second">{sn}s</span>'
              });
          }
        });
    },
    _initReviews: function() {
      "undefined" != typeof SPR &&
        (SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges());
    },
    onUnload: function() {
      this.$container.off(this.SearchNamspace);
    }
  })), e;
})()), (theme.footerSection = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.footerId = $("#shopify-section-" + i)), (this.footer = $(
      "#site-" + i
    )), (this.footerNamespace = "#site-" + i), (this.footerNewsletterForm = $(
      "#mc-form-" + i
    )), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {
      this._initFooter(), 0 < this.footerNewsletterForm.length &&
        this._initMailChimp();
    },
    _initFooter: function() {
      "1" == $("#site-footer").data("parallax")
        ? ($(document.body)
            .removeClass("footer-no-parallax")
            .addClass("footer-parallax"), $(window)
            .on("resize", function() {
              var e = $("#site-footer .footer-layout").outerHeight(!0);
              if (
                ($(document.body).css("padding-bottom", e), $(
                  document.body
                ).hasClass("page-header-layout-3") &&
                  "1" == $(".page-header").data("parallax"))
              ) {
                $("#site-footer").addClass("has-parallax");
                var t = $(".page-header").height();
                $(window).on("scroll", function() {
                  $(window).scrollTop() > t
                    ? $("#site-footer").addClass("active")
                    : $("#site-footer").removeClass("active");
                });
              }
            })
            .trigger("resize"))
        : $(document.body)
            .removeClass("footer-parallax")
            .addClass("footer-no-parallax");
    },
    _initMailChimp: function() {
      var e = this.footerNewsletterForm, t = e.attr("action");
      e.ajaxChimp({
        url: t,
        callback: function(t) {
          "success" == t.result
            ? (jQuery("#rtp-message").html(t.msg), jQuery(
                "#rt-unero-popup-message"
              )
                .css(
                  "margin-left",
                  "-" +
                    parseFloat(jQuery("#rt-unero-popup-message").width()) / 2 +
                    "px"
                )
                .fadeIn(), window.setTimeout(function() {
                jQuery("#rt-unero-popup-message").fadeOut();
              }, 2e3), e.find(".mc4wp-response").removeClass("error").hide())
            : e.find(".mc4wp-response").addClass("error").html(t.msg).show();
        }
      });
    },
    onUnload: function() {
      this.$container.off(this.footerNamespace);
    }
  })), e;
})()), (theme.sideBarSection = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.sidebarId = $("#shopify-section-" + i)), (this.sidebar = $(
      "#menu-sidebar-" + i
    )), (this.sidebarNamespace = "#menu-sidebar-" + i), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {
      this._initMenu();
    },
    _initMenu: function() {
      $(".sidebar-child-menu").unbind("click"), $(
        ".sidebar-child-menu"
      ).click(function(e) {
        e.preventDefault(), $(this).closest("li").siblings().find("ul").slideUp(), $(this).closest("li").siblings().removeClass("active"), $(this).closest("li").siblings().find("li").removeClass("active"), $(this).closest("li").children("ul").slideToggle(), $(this).closest("li").toggleClass("active"), $(this).toggleClass("active");
      });
    },
    onUnload: function() {
      this.$container.off(this.sidebarNamespace);
    }
  })), e;
})()), (theme.mobileNavSection = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.mobileNavId = $("#shopify-section-" + i)), (this.mobileNav = $(
      "#primary-" + i
    )), (this.mobilenavNamespace = "#primary-" + i), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {
      this._initMobile();
    },
    _initMobile: function() {
      var e = this.mobileNav;
      $("#header-header").on("click", "#un-navbar-toggle", function(t) {
        t.preventDefault(), e.toggleClass("open"), $(document.body).toggleClass("open-canvas-panel");
      }), e.on("click", ".mobile-child-menu", function(e) {
        e.preventDefault(), $(this).closest("li").siblings().find("ul").slideUp(), $(this).closest("li").siblings().removeClass("active"), $(this).closest("li").siblings().find("li").removeClass("active"), $(this).closest("li").children("ul").slideToggle(), $(this).closest("li").toggleClass("active");
      }), 0 < $(".mobile-nav-footer").length &&
        $(".mobile-nav-footer").on("click", ".toggle-children", function(e) {
          e.preventDefault(), $(this).closest("li").siblings().find("ul").slideUp(), $(this).closest("li").siblings().removeClass("active"), $(this).closest("li").siblings().find("li").removeClass("active"), $(this).closest("li").children("ul").slideToggle(), $(this).closest("li").toggleClass("active");
        }), e.on("click", ".close-canvas-mobile-panel", function(e) {
        e.preventDefault(), $(document.body).removeClass("open-canvas-panel"), $(".unero-off-canvas-panel, #primary-mobile-nav").removeClass("open");
      }), $(window).on("resize", function() {
        991 < $(window).width() &&
          e.hasClass("open") &&
          (e.removeClass("open"), $(document.body).removeClass(
            "open-canvas-panel"
          ));
      });
    },
    onUnload: function() {
      this.$container.off(this.mobilenavNamespace);
    }
  })), e;
})()), (theme.CollectionTemplate = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.CollectionId = $("#collection-" + i)), (this.Collection = $(
      "#collection-" + i
    )), (this.CollectionNamspace =
      "#collection-" +
      i), (this.collection_infinite_scoll = this.Collection.data(
      "collection_infinite_scoll"
    )), (this.collection_infinite_scoll_auto = this.Collection.data(
      "collection_infinite_scoll_auto"
    )), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {
      this._initCollectionFilter();
    },
    _initCollectionFilter: function() {
      function e(e) {
        delete Shopify.queryParams.page, (function(e) {
          var o = $("#un-shop-content"),
            n = $("#primary-sidebar"),
            a = $("#primary-offcanvas"),
            s = $("#un-categories-filter"),
            r = $("#un-shop-topbar"),
            c = $(".product-found > span"),
            l = $(".shop-toolbar .rt-unero-ordering");
          if (0 < $("#un-shop-toolbar").length) {
            var d = $("#un-shop-toolbar").offset().top - 200;
            $("html, body").stop().animate({ scrollTop: d }, 1200);
          }
          $("#un-shop-loading").addClass("show"), $.ajax({
            type: "get",
            url: e,
            beforeSend: function() {
              ($("#un-shop-toolbar").hasClass("on-mobile") ||
                $("#un-shop-topbar").hasClass("on-mobile")) &&
                ($("#un-categories-filter").slideUp(), $(
                  "#un-shop-topbar"
                ).slideUp(), $("#un-toggle-cats-filter").removeClass(
                  "active"
                ), $(".un-filter").removeClass("active"));
            },
            success: function(d) {
              o.replaceWith($(d).find("#un-shop-content")), n.html(
                $(d).find(".catalog-sidebar").html()
              ), a.html($(d).find(".catalog-offcanvas").html()), s.html(
                $(d).find("#un-categories-filter").html()
              ), r.html($(d).find("#un-shop-topbar").html()), c.html(
                $(d).find(".product-found > span").html()
              ), l.html(
                $(d).find(".shop-toolbar .rt-unero-ordering").html()
              ), "?" == e.slice(-1) && (e = e.slice(0, -1)), (e = e.replace(
                /%2C/g,
                ","
              )), history.pushState(
                null,
                null,
                e
              ), theme.roarApplication.initLoadMore(), (t = !0), (i = !0), theme.CurrencyPicker.convert(
                ".un-shop-content .money"
              ), $("#un-shop-loading").removeClass("show"), 0 <
                $(".wc-layered-nav-term.chosen").length
                ? $("#remove-filter-actived").removeClass("hide")
                : $("#remove-filter-actived").addClass("hide");
            },
            error: function() {
              $("#un-shop-loading").removeClass("show");
            }
          });
        })(
          (function(e) {
            var t = $.param(Shopify.queryParams).replace(/%2B/g, "+");
            return e ? "" == t ? e : e + "?" + t : location.pathname + "?" + t;
          })(e)
        );
      }
      if (
        (0 < $(".shop-bottombar").length &&
          $(window)
            .on("scroll", function() {
              $(document.body).find("#un-shop-footer").is(":in-viewport")
                ? $(".shop-bottombar")
                    .find(".un-filter")
                    .addClass("not-viewport")
                : $(".shop-bottombar")
                    .find(".un-filter")
                    .removeClass("not-viewport");
            })
            .trigger("scroll"), $(
          "body"
        ).on("click", ".wc-layered-nav-term a", function(t) {
          t = $(this).parent();
          var i = $(this).data("value"), o = [];
          if (
            (Shopify.queryParams.constraint &&
              (o = Shopify.queryParams.constraint.split(
                "+"
              )), !window.enable_filter_multiple_choice &&
              !t.hasClass("chosen"))
          ) {
            var n = t.parents(".wc-layered-nav-term").find(".chosen");
            0 < n.length &&
              n.each(function() {
                var e = $(this).data("handle");
                if (($(this).removeClass("chosen"), e)) {
                  var t = o.indexOf(e);
                  0 <= t && o.splice(t, 1);
                }
              });
          }
          if (i) {
            var a = o.indexOf(i);
            0 > a
              ? (o.push(i), t.addClass("chosen"))
              : (o.splice(a, 1), t.removeClass("chosen"));
          }
          o.length
            ? (Shopify.queryParams.constraint = o.join("+"))
            : delete Shopify.queryParams.constraint, e();
        }), $("body").on("click", ".rt-unero-pagination a", function(t) {
          var i = $(this);
          delete Shopify
            .queryParams.page, delete Shopify.queryParams.constraint, delete Shopify.queryParams.q, delete Shopify.queryParams.sort_by, e(i.attr("href")), t.preventDefault();
        }), $("body").on("click", ".rt-unero-ordering a", function(t) {
          var i = $(this), o = i.data("sort");
          $(".rt-unero-ordering a").removeClass(
            "active"
          ), i.addClass("active"), (Shopify.queryParams.sort_by = o), e(), t.preventDefault();
        }), $("body").on("click", "#unero_product_tag_cloud a", function(t) {
          t = $(this);
          var i = $(this).data("value"), o = [];
          if (
            (Shopify.queryParams.constraint &&
              (o = Shopify.queryParams.constraint.split(
                "+"
              )), !window.enable_filter_multiple_choice &&
              !t.hasClass("selected"))
          ) {
            var n = t.parents(".tagcloud").find(".selected");
            0 < n.length &&
              n.each(function() {
                var e = $(this).data("handle");
                if (($(this).removeClass("selected"), e)) {
                  var t = o.indexOf(e);
                  0 <= t && o.splice(t, 1);
                }
              });
          }
          if (i) {
            var a = o.indexOf(i);
            0 > a
              ? (o.push(i), t.addClass("selected"))
              : (o.splice(a, 1), t.removeClass("selected"));
          }
          o.length
            ? (Shopify.queryParams.constraint = o.join("+"))
            : delete Shopify.queryParams.constraint, e();
        }), "1" == this.collection_infinite_scoll)
      ) {
        var t = !0, i = !0;
        "1" == this.collection_infinite_scoll_auto &&
          $(window).scroll(function() {
            var e = $(".load_more");
            if (0 < e.length) {
              var t = $(window),
                o = t.scrollTop(),
                n = o + t.height(),
                a = e.offset().top;
              a + e.height() <= n &&
                a >= o &&
                i &&
                ((i = !1), e.find("a").trigger("click"));
            }
          }), $("body").on("click", ".load_more a", function(e) {
          return (function() {
            var e = $(".load_more").last(),
              o = $(".load_more a").last().attr("href");
            0 < e.length &&
              t &&
              $.ajax({
                type: "GET",
                url: o,
                beforeSend: function() {
                  jQuery(".load_more").hide(), jQuery("#un-products-loading")
                    .toggleClass("hide")
                    .fadeIn();
                },
                success: function(e) {
                  var o = jQuery(".products"),
                    n = jQuery(e).find(".products .product");
                  if (
                    ($(document.body).hasClass("catalog-board-content") ||
                      $(document.body).hasClass("collection-metro-content")
                      ? n.imagesLoaded(function() {
                          o.isotope(
                            "insert",
                            n
                          ), theme.roarApplication.initLoadMore();
                        })
                      : (o.append(
                          n
                        ), theme.roarApplication.initLoadMore()), jQuery(
                      "#un-products-loading"
                    )
                      .toggleClass("hide")
                      .fadeOut(), $(document.body)
                      .find("img.lazy")
                      .lazyload(), jQuery(e).find(".load_more a").length)
                  ) {
                    jQuery(".load_more a")
                      .last()
                      .attr(
                        "href",
                        jQuery(e).find(".load_more a").last().attr("href")
                      ), jQuery(".load_more").show(), (i = !0);
                    var a = parseInt(
                      jQuery(e).find(".load_more a").last().data("page")
                    );
                    if (0 < a) {
                      var s =
                        a * parseInt($(".page-num-offset").data("page_size"));
                      parseInt($(".page-num-offset").data("total_result")) >
                        s &&
                        $(".result-offset").html(s).css("padding-right", "5px");
                    } else
                      $(".page-num-offset").html(
                        $(".page-num-offset").data("total_result")
                      );
                  } else
                    (t = !1), jQuery(".load_more").remove(), $(
                      ".page-num-offset"
                    ).html($(".page-num-offset").data("total_result"));
                  theme.CurrencyPicker.convert(".un-shop-content .money");
                },
                dataType: "html"
              });
          })(), e.stopPropagation(), !1;
        });
      }
      $("body").on("click", "#remove-filter-actived", function(t) {
        delete Shopify
          .queryParams.page, delete Shopify.queryParams.constraint, delete Shopify.queryParams.q, e(), t.preventDefault();
      });
    },
    _initReviews: function() {
      "undefined" != typeof SPR &&
        (SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges());
    },
    onUnload: function() {
      this.$container.off(this.SearchNamspace);
    }
  })), e;
})()), (theme.CollectionInstagramTemplate = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.collectionId = $("#shopify-section-" + i)), (this.collection = $(
      "#collection-" + i
    )), (this.collectionNamespace = "#collection-" + i), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {
      this._initInstafeed();
    },
    _initInstafeed: function() {
      var e = "shop-instagram-" + this.sectionId,
        t = this.collection.data("token"),
        i = this.collection.data("id"),
        o = this.collection.data("limit");
      new Instafeed({
        get: "user",
        target: e,
        accessToken: t,
        userId: i,
        limit: o,
        resolution: "standard_resolution",
        resolution2: "standard_resolution",
        template: '<div class="wrap animated"><a class="fauximg-bin" target="_blank" href="{{link}}"><figure class="snpt__fauximg" style="background-image: url({{image}})"></figure><i class="t-icon icon-bag2 snptlinked-item-ico"></i></a><div class="snptcrd__ovrly"><div class="ovrly_content snpt-atm sfx-scale-up"><div class="snpt-atm-el sfx__animated"><div class="snptcrd__button"><i class="t-icon icon-bag2"></i></div></div></div></div></div>'
      }).run();
    },
    onUnload: function() {
      this.$container.off(this.collectionNamespace);
    }
  })), e;
})()), (theme.CollectionsTemplate = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.CollectionsId = $("#shopify-section-" + i)), (this.Collections = $(
      "#unero-site-content"
    )), (this.CollectionsNamspace =
      "#unero-site-content"), (this.collection_infinite_scoll = this.Collections.data(
      "collection_infinite_scoll"
    )), (this.collection_infinite_scoll_auto = this.Collections.data(
      "collection_infinite_scoll_auto"
    )), (this.pInfScrLoading = !1), (this.pInfScrMore = !0), (this.flagScroll = !0), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {
      this._initCollectionControl();
    },
    _initCollectionControl: function() {
      var e = this;
      "1" == this.collection_infinite_scoll &&
        ("1" == this.collection_infinite_scoll_auto &&
          $(window).scroll(function() {
            var t = $(".load_more");
            if (0 < t.length) {
              var i = $(window),
                o = i.scrollTop(),
                n = o + i.height(),
                a = t.offset().top;
              a + t.height() <= n &&
                a >= o &&
                e.flagScroll &&
                ((e.flagScroll = !1), t.find("a").trigger("click"));
            }
          }), jQuery(".load_more a").click(function(t) {
          return e._pInfScrExecute(), t.stopPropagation(), !1;
        }));
    },
    _pInfScrExecute: function() {
      var e = this,
        t = $(".load_more").last(),
        i = $(".load_more a").last().attr("href");
      0 < t.length &&
        e.pInfScrMore &&
        $.ajax({
          type: "GET",
          url: i,
          beforeSend: function() {
            jQuery(".load_more").hide(), jQuery("#un-products-loading")
              .toggleClass("hide")
              .fadeIn();
          },
          success: function(t) {
            var i = $(t).find(".unero-post-list").children(".un-post-item");
            if (
              (i.imagesLoaded(function() {
                $(".unero-post-list").append(i).isotope("insert", i);
              }), jQuery("#un-products-loading")
                .toggleClass("hide")
                .fadeOut(), $(document.body)
                .find("img.lazy")
                .lazyload(), jQuery(t).find(".load_more a").length)
            ) {
              jQuery(".load_more a")
                .last()
                .attr(
                  "href",
                  jQuery(t).find(".load_more a").last().attr("href")
                ), jQuery(".load_more").show(), (e.flagScroll = !0);
              var o = parseInt(
                jQuery(t).find(".load_more a").last().data("page")
              );
              if (0 < o) {
                var n = o * parseInt($(".page-num-offset").data("page_size"));
                parseInt($(".page-num-offset").data("total_result")) > n &&
                  $(".result-offset").html(n).css("padding-right", "5px");
              } else
                $(".page-num-offset").html(
                  $(".page-num-offset").data("total_result")
                );
            } else
              (e.pInfScrMore = !1), jQuery(".load_more").remove(), $(
                ".page-num-offset"
              ).html($(".page-num-offset").data("total_result"));
          },
          dataType: "html"
        });
    },
    _initReviews: function() {
      "undefined" != typeof SPR &&
        (SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges());
    },
    onUnload: function() {
      this.$container.off(this.CollectionsNamspace);
    }
  })), e;
})()), (theme.BlogTemplate = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.BlogId = $("#shopify-section-" + i)), (this.Blog = $(
      "#unero-site-content"
    )), (this.BlogNamspace =
      "#unero-site-content"), (this.collection_infinite_scoll = this.Blog.data(
      "collection_infinite_scoll"
    )), (this.collection_infinite_scoll_auto = this.Blog.data(
      "collection_infinite_scoll_auto"
    )), (this.sidebar = this.Blog.data(
      "sidebar"
    )), (this.pInfScrLoading = !1), (this.pInfScrMore = !0), (this.flagScroll = !0), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {
      this._initCollectionControl(), "" != this.sidebar &&
        $(document.body).removeClass("full-content").addClass(this.sidebar);
    },
    _initCollectionControl: function() {
      var e = this;
      "1" == this.collection_infinite_scoll &&
        ("1" == this.collection_infinite_scoll_auto &&
          $(window).scroll(function() {
            var t = $(".load_more");
            if (0 < t.length) {
              var i = $(window),
                o = i.scrollTop(),
                n = o + i.height(),
                a = t.offset().top;
              a + t.height() <= n &&
                a >= o &&
                e.flagScroll &&
                ((e.flagScroll = !1), t.find("a").trigger("click"));
            }
          }), jQuery(".load_more a").click(function(t) {
          return e._pInfScrExecute(), t.stopPropagation(), !1;
        }));
    },
    _pInfScrExecute: function() {
      var e = this,
        t = $(".load_more").last(),
        i = $(".load_more a").last().attr("href");
      0 < t.length &&
        e.pInfScrMore &&
        $.ajax({
          type: "GET",
          url: i,
          beforeSend: function() {
            jQuery(".load_more").hide(), jQuery("#un-products-loading")
              .toggleClass("hide")
              .fadeIn();
          },
          success: function(t) {
            var i = $(t).find(".unero-post-list").children(".un-post-item");
            if (
              ($("#unero-site-content").hasClass("blog-layout-masonry")
                ? i.imagesLoaded(function() {
                    $(".unero-post-list").append(i).isotope("insert", i);
                  })
                : $(".unero-post-list").append(i), jQuery(
                "#un-products-loading"
              )
                .toggleClass("hide")
                .fadeOut(), $(document.body)
                .find("img.lazy")
                .lazyload(), jQuery(t).find(".load_more a").length)
            ) {
              jQuery(".load_more a")
                .last()
                .attr(
                  "href",
                  jQuery(t).find(".load_more a").last().attr("href")
                ), jQuery(".load_more").show(), (e.flagScroll = !0);
              var o = parseInt(
                jQuery(t).find(".load_more a").last().data("page")
              );
              if (0 < o) {
                var n = o * parseInt($(".page-num-offset").data("page_size"));
                parseInt($(".page-num-offset").data("total_result")) > n &&
                  $(".result-offset").html(n).css("padding-right", "5px");
              } else
                $(".page-num-offset").html(
                  $(".page-num-offset").data("total_result")
                );
            } else
              (e.pInfScrMore = !1), jQuery(".load_more").remove(), $(
                ".page-num-offset"
              ).html($(".page-num-offset").data("total_result"));
          },
          dataType: "html"
        });
    },
    onUnload: function() {
      this.$container.off(this.BlogNamspace);
    }
  })), e;
})()), (theme.portfolioMasonry = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.portfolioId = $("#shopify-section-" + i)), (this.portfolio = $(
      "#unero-site-content"
    )), (this.portfolioNamspace = "#unero-site-content"), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {},
    onUnload: function() {
      this.$container.off(this.portfolioNamspace);
    }
  })), e;
})()), (theme.portfolioCarousel = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.portfolioId = $("#shopify-section-" + i)), (this.portfolio = $(
      "#unero-site-content"
    )), (this.portfolioNamspace = "#unero-site-content"), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {},
    onUnload: function() {
      this.$container.off(this.portfolioNamspace);
    }
  })), e;
})()), (theme.ArticleTemplate = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.articleId = $("#shopify-section-" + i)), (this.article = $(
      ".article-" + i
    )), (this.articleNamspace = ".article-" + i), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {
      this._initRecommended();
    },
    _initRecommended: function() {
      var e = $(this.articleNamspace + " .related.products ul.products");
      0 < e.length &&
        "1" == e.data("slide_enable") &&
        e
          .not(".slick-initialized")
          .slick({
            slidesToShow: e.data("per_view"),
            slidesToScroll: e.data("per_view"),
            arrows: !1,
            lazyLoad: "ondemand",
            dots: !0,
            responsive: [
              {
                breakpoint: 1200,
                settings: { slidesToShow: 3, slidesToScroll: 1 }
              },
              {
                breakpoint: 767,
                settings: { slidesToShow: 2, slidesToScroll: 1 }
              }
            ]
          });
    },
    onUnload: function() {
      this.$container.off(this.articleNamspace);
    }
  })), e;
})()), (theme.faqsTemplate = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.faqsId = $("#shopify-section-" + i)), (this.faqs = $(
      "#content"
    )), (this.faqsNamspace = "#content"), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {},
    onUnload: function() {
      this.$container.off(this.faqsNamspace);
    }
  })), e;
})()), (theme.aboutTemplate = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.aboutId = $("#shopify-section-" + i)), (this.about = $(
      "#content"
    )), (this.aboutNamspace = "#content"), (this.aboutSlide = $(
      "#slide-" + i
    )), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {
      this._initSlide();
    },
    _initSlide: function() {
      var e = this.aboutSlide;
      e
        .not(".slick-initialized")
        .slick({
          slidesToShow: parseInt(e.data("per_view")),
          slidesToScroll: 1,
          lazyLoad: "ondemand",
          dots: !1,
          arrows: !1,
          responsive: [
            {
              breakpoint: 1200,
              settings: { slidesToShow: 4, slidesToScroll: 1 }
            },
            {
              breakpoint: 767,
              settings: { slidesToShow: 4, slidesToScroll: 1 }
            },
            {
              breakpoint: 500,
              settings: { slidesToShow: 3, slidesToScroll: 1 }
            }
          ]
        });
    },
    onUnload: function() {
      this.$container.off(this.aboutNamspace);
    }
  })), e;
})()), (theme.SliderSection = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.sliderId = $("#shopify-section-" + i)), (this.slider = $(
      "#" + i
    )), (this.sliderNamspace = "#" + i), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {
      "1" == this.slider.data("parallax")
        ? ($(document.body).hasClass("header-slider-top") &&
            $(document.body).removeClass("header-slider-noparallax"), $(
            document.body
          )
            .removeClass("page-header-layout-1")
            .addClass("page-header-layout-3"), (function() {
            if ($(".page-header").hasClass("page-header-sliders")) {
              var e = $(".page-header-sliders"),
                t = e.data("speed"),
                i = !1,
                o = e.data("auto"),
                n = e.data("parallax");
              if (
                ("1" == n && (i = !0), e
                  .find("ul")
                  .not(".slick-initialized")
                  .slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: !0,
                    autoplaySpeed: t,
                    autoplay: o,
                    fade: i,
                    cssEase: "linear",
                    prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
                    nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>'
                  }), "0" == n)
              )
                $(".page-header-sliders.parallax")
                  .find("li")
                  .parallax("50%", 0.6);
              else {
                var a = e.height();
                $(document.body).hasClass("admin-bar") && (a -= 32), $(
                  "#content"
                ).css("margin-top", a), e.addClass("parallax-2"), $(
                  window
                ).on("scroll", function() {
                  var e = $(window).scrollTop();
                  0 < e
                    ? $(".page-header-sliders.parallax-2").css({
                        opacity: (a - e) / a
                      })
                    : $(".page-header-sliders.parallax-2").css({ opacity: 1 });
                });
              }
            } else $(".page-header.parallax").parallax("50%", 0.6);
          })())
        : ($(document.body).hasClass("header-slider-top") &&
            $(document.body).addClass("header-slider-noparallax"), $(
            document.body
          ).addClass("page-header-layout-1")), this._initSlider();
    },
    _initSlider: function() {
      if (this.slider.hasClass("page-header-sliders")) {
        var e = this.slider,
          t = e.data("speed"),
          i = !1,
          o = e.data("auto"),
          n = e.data("parallax");
        if (
          ("1" == n && (i = !0), e
            .find("ul")
            .not(".slick-initialized")
            .slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: !0,
              autoplaySpeed: t,
              autoplay: o,
              fade: i,
              cssEase: "linear",
              prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
              nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>'
            }), "" == n)
        )
          $(".page-header-sliders.parallax").find("li").parallax("50%", 0.6);
        else {
          var a = e.height();
          $(document.body).hasClass("admin-bar") && (a -= 32), $(
            "#content"
          ).css("margin-top", a), e.addClass("parallax-2"), $(
            window
          ).on("scroll", function() {
            var e = $(window).scrollTop();
            0 < e
              ? $(".page-header-sliders.parallax-2").css({
                  opacity: (a - e) / a
                })
              : $(".page-header-sliders.parallax-2").css({ opacity: 1 });
          });
        }
      } else $(".page-header.parallax").parallax("50%", 0.6);
    },
    onUnload: function() {
      this.$container.off(this.sliderNamspace);
    }
  })), e;
})()), (theme.uneroSliderSection = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.uneroSliderId = $(
      "#unero-sliders-wrapper-" + i
    )), (this.uneroSlider = $(
      "#unero-sliders-" + i
    )), (this.uneroSliderNamspace = "#unero-sliders-" + i), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {
      this._initUneroSlide();
    },
    _initUneroSlide: function() {
      var e = !1,
        t = !1,
        i = !1,
        o = parseInt(this.uneroSliderId.data("height")),
        n = parseInt(this.uneroSliderId.data("parallax")),
        a = this.uneroSliderId.data("speed"),
        s = this.uneroSliderId.data("autoplay"),
        r = "1" == this.uneroSliderId.data("dots"),
        c = this.uneroSlider;
      "1" == this.uneroSliderId.data("autoplay") && (e = !0), "1" == n &&
        (t = !0), "1" == this.uneroSliderId.data("direction") &&
        (i = !0), c
        .not(".slick-initialized")
        .slick({
          rtl: i,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplaySpeed: a,
          dots: r,
          autoplay: s,
          infinite: e,
          fade: t,
          lazyLoad: "ondemand",
          prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
          nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>'
        }), $(window)
        .on("resize", function() {
          if (0 < o) {
            var e = $(window).width();
            c.height(e * o / 1903);
          }
        })
        .trigger("resize"), "1" == n &&
        c
          .find(".featured-img")
          .parallax("50%", 0.6), c.imagesLoaded(function() {
        c.addClass("loaded");
      });
      var l = c.find(".unvideo-bg").find("video");
      0 < l.length && l[0].play(), c.on("afterChange", function(e, t, i) {
        var o = c
          .find('.slick-slide[data-slick-index="' + i + '"]')
          .find("video");
        0 < o.length && o[0].play();
      }), c.on("beforeChange", function(e, t, i) {
        var o = c
          .find('.slick-slide[data-slick-index="' + i + '"]')
          .find("video");
        0 < o.length && o[0].pause();
      });
    },
    onUnload: function() {
      this.$container.off(this.uneroSliderNamspace);
    }
  })), e;
})()), (theme.uneroHeroSliderSection = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.uneroHeroSliderId = $(
      "#shopify-section-" + i
    )), (this.uneroHeroSlider = $(
      "#unero-hero-slider-" + i
    )), (this.uneroHeroSliderNamspace =
      "#unero-hero-slider-" + i), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {
      this._initUneroHeroSlide();
    },
    _initUneroHeroSlide: function() {
      $(
        ".unero-hero-slider"
      ).on("mouseover touchstart", ".item-content", function() {
        var e = $(this),
          t = e.index(),
          i = e.closest(".unero-hero-slider").find(".item-image");
        i.removeClass(
          "active"
        ), e.siblings().removeClass("active"), e.addClass("active"), i.filter(":eq(" + t + ")").addClass("active");
      });
    },
    onUnload: function() {
      this.$container.off(this.uneroHeroSliderNamspace);
    }
  })), e;
})()), (theme.uneroCollectionsSection = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.uneroCollectionsId = $(
      "#unero-banners-carousel-" + i
    )), (this.uneroCollections = $(
      "#banners-carousel-" + i
    )), (this.uneroCollectionsNamspace =
      "#banners-carousel-" + i), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {
      "1" == this.uneroCollectionsId.data("slide_enable") &&
        this._initUneroCollections();
    },
    _initUneroCollections: function() {
      var e = !1,
        t = !1,
        i = this.uneroCollectionsId.data("speed"),
        o = this.uneroCollectionsId.data("autoplay"),
        n = this.uneroCollectionsId.data("perview"),
        a = this.uneroCollections;
      "1" == this.uneroCollectionsId.data("autoplay") && (e = !0), "1" ==
        this.uneroCollectionsId.data("direction") && (t = !0), a
        .not(".slick-initialized")
        .slick({
          rtl: t,
          slidesToShow: n,
          slidesToScroll: 1,
          autoplaySpeed: i,
          autoplay: o,
          infinite: e,
          lazyLoad: "ondemand",
          prevArrow: '<span class="icon-arrow-left slick-prev-arrow"></span>',
          nextArrow: '<span class="icon-arrow-right slick-next-arrow"></span>',
          responsive: [
            {
              breakpoint: 1200,
              settings: { slidesToShow: 2, slidesToScroll: 1 }
            },
            {
              breakpoint: 600,
              settings: { slidesToShow: 1, slidesToScroll: 1 }
            }
          ]
        }), a.imagesLoaded(function() {
        a.addClass("loaded");
      });
    },
    onUnload: function() {
      this.$container.off(this.uneroCollectionsNamspace);
    }
  })), e;
})()), (theme.uneroCollectionsMasonrySection = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.uneroCollectionsId = $(
      "#shopify-section-" + i
    )), (this.uneroCollections = $(
      "#unero-collections-masonry-wrapper-" + i
    )), (this.uneroCollectionsNamspace =
      "#unero-collections-masonry-wrapper-" + i), (this.uneroBanner = $(
      ".unero-banner-" + i
    )), (this.uneroNewsletter = $("#mc-form.newsletter-" + i)), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {
      0 < this.uneroBanner.length &&
        this.uneroBanner.each(function() {
          var e = $(this).find(".text").width(),
            t = -1 * (e / 2 + 25),
            i = $(this).find(".data-height").data("height");
          $(this).hasClass("text-align-left")
            ? $(this).find(".text").css("left", t)
            : $(this)
                .find(".text")
                .css(
                  "right",
                  t
                ), $(this).hasClass("text-position-center") && $(this).find(".text").css("top", (i - e) / 2);
        }), 0 < this.uneroNewsletter.length && this._initNewsletter();
    },
    _initNewsletter: function() {
      var e = this.uneroNewsletter, t = e.attr("action");
      e.ajaxChimp({
        url: t,
        callback: function(e) {
          e.result;
        }
      });
    },
    onUnload: function() {
      this.$container.off(this.uneroCollectionsNamspace);
    }
  })), e;
})()), (theme.uneroBannerSection = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.uneroBannerId = $("#shopify-section-" + i)), (this.uneroBanner = $(
      "#unero-banners-grid-" + i
    )), (this.uneroBannerNamspace = "#unero-banners-grid-" + i), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {},
    onUnload: function() {
      this.$container.off(this.uneroBannerNamspace);
    }
  })), e;
})()), (theme.uneroBannerMetroSection = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.uneroBannerId = $("#shopify-section-" + i)), (this.uneroBanner = $(
      "#unero-banners-metro-" + i
    )), (this.uneroBannerNamspace = "#unero-banners-metro-" + i), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {
      this._initMasonry();
    },
    _initMasonry: function() {
      var e = this.uneroBanner;
      e.find(".unero-banners-metro-content").imagesLoaded(function() {
        e
          .find(".unero-banners-metro-content")
          .isotope({ itemSelector: ".banner-item", layoutMode: "packery" });
      });
    },
    onUnload: function() {
      this.$container.off(this.uneroBannerNamspace);
    }
  })), e;
})()), (theme.uneroAboutSection = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.uneroAboutId = $("#shopify-section-" + i)), (this.uneroAbout = $(
      "#unero-about-wrapper-" + i
    )), (this.uneroAboutNamspace = "#unero-about-wrapper-" + i), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {},
    onUnload: function() {
      this.$container.off(this.uneroAboutNamspace);
    }
  })), e;
})()), (theme.uneroProductsCarouselSection = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.carouselId = $(
      "#unero-products-carousel-wrapper-" + i
    )), (this.carousel = $(
      ".unero-products-carousel-" + i
    )), (this.carouselNamspace = "#unero-products-carousel-" + i), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {
      0 < this.carousel.length &&
        this.carousel.each(function() {
          if ("1" == $(this).data("slide")) {
            var e = $(this),
              t = $(this).data("perview"),
              i = $(this).data("autoplay"),
              o = $(this).data("speed"),
              n = !1;
            "1" == i && (n = !0), e
              .not(".slick-initialized")
              .slick({
                rtl: !1,
                slidesToShow: t,
                slidesToScroll: 1,
                autoplaySpeed: o,
                autoplay: i,
                infinite: n,
                lazyLoad: "ondemand",
                prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
                nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>',
                responsive: [
                  {
                    breakpoint: 1200,
                    settings: { slidesToShow: 3, slidesToScroll: 1 }
                  },
                  {
                    breakpoint: 767,
                    settings: { slidesToShow: 2, slidesToScroll: 1 }
                  }
                ]
              });
          }
        });
    },
    onUnload: function() {
      this.$container.off(this.carouselNamspace);
    }
  })), e;
})()), (theme.uneroInstagramSection = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.uneroInstagramId = $(
      "#unero-instagram-wrapper-" + i
    )), (this.uneroInstagram = $(
      "#unero-instagram-" + i
    )), (this.uneroInstagramNamspace =
      "#unero-instagram-" + i), (this.uneroInstagramTarget =
      "unero-instagram-" + i), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {
      "carousel" == this.uneroInstagram.data("type")
        ? this._initCarousel()
        : this._initGrid();
    },
    _initGrid: function() {
      var e = this.uneroInstagram,
        t = this.uneroInstagramTarget,
        i = e.attr("data-id"),
        o = e.attr("data-token"),
        n = e.attr("data-limit");
      new Instafeed({
        get: "user",
        target: t,
        accessToken: o,
        userId: parseInt(i),
        limit: parseInt(n),
        resolution: "standard_resolution",
        resolution2: "standard_resolution",
        template: '<div class="wrap animated"><a class="fauximg-bin" target="_blank" href="{{link}}"><figure class="snpt__fauximg" style="background-image: url({{image}})"></figure><i class="t-icon icon-bag2 snptlinked-item-ico"></i></a><div class="snptcrd__ovrly"><div class="ovrly_content snpt-atm sfx-scale-up"><div class="snpt-atm-el sfx__animated"><div class="snptcrd__button"><i class="t-icon icon-bag2"></i></div></div></div></div></div>'
      }).run();
    },
    _initCarousel: function() {
      var e = this.uneroInstagram,
        t = this.uneroInstagramTarget,
        i = e.attr("data-id"),
        o = e.attr("data-token"),
        n = e.attr("data-limit"),
        a = e.data("perview"),
        s = e.data("autoplay"),
        r = !1,
        c = e.data("speed");
      new Instafeed({
        get: "user",
        target: t,
        accessToken: o,
        userId: parseInt(i),
        limit: parseInt(n),
        resolution: "standard_resolution",
        resolution2: "standard_resolution",
        template: '<li class="product"><a class="insta-item" target="_blank" href="{{link}}" style="background-image:url({{image}});"><i class="social_instagram"></i></a></li>',
        after: function() {
          0 < s ? ((r = !0), (s = !0)) : (s = !1), e
            .not(".slick-initialized")
            .slick({
              slidesToShow: a,
              slidesToScroll: 1,
              autoplaySpeed: c,
              autoplay: s,
              infinite: r,
              dots: !1,
              prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
              nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>',
              responsive: [
                {
                  breakpoint: 1200,
                  settings: { slidesToShow: 4, slidesToScroll: 1 }
                },
                {
                  breakpoint: 767,
                  settings: { slidesToShow: 3, slidesToScroll: 1 }
                }
              ]
            });
        }
      }).run();
    },
    onUnload: function() {
      this.$container.off(this.uneroInstagramNamspace);
    }
  })), e;
})()), (theme.unseroBlogSection = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.unseroBlogId = $("#shopify-section-" + i)), (this.unseroBlog = $(
      "#unero-posts-" + i
    )), (this.unseroBlogNamspace = "#unero-posts-" + i), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {},
    onUnload: function() {
      this.$container.off(this.unseroBlogNamspace);
    }
  })), e;
})()), (theme.toTopSection = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.toTopId = $("#shopify-section-" + i)), (this.toTop = $(
      "#to-top-" + i
    )), (this.toTopNamespace = "#to-top-" + i), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {
      this._initToTop();
    },
    _initToTop: function() {
      var e = $(".cd-top");
      $(window).scroll(function() {
        $(this).scrollTop() > 300
          ? e.addClass("cd-is-visible")
          : e.removeClass(
              "cd-is-visible cd-fade-out"
            ), $(this).scrollTop() > 1200 && e.addClass("cd-fade-out");
      }), e.on("click", function(e) {
        e.preventDefault(), $("body,html").animate({ scrollTop: 0 }, 700);
      });
    },
    onUnload: function() {
      this.$container.off(this.toTopNamespace);
    }
  })), e;
})()), (theme.unseroNewsletterSection = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.unseroNewsletterId = $(
      "#shopify-section-" + i
    )), (this.unseroNewsletter = $(
      "#unero-newsletter-" + i
    )), (this.unseroNewsletterNamspace =
      "#unero-newsletter-" + i), (this.uneroNewsletterForm = $(
      "#mc-form.newsletter-" + i
    )), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {
      var e = this.uneroNewsletterForm, t = e.attr("action");
      e.ajaxChimp({
        url: t,
        callback: function(e) {
          e.result;
        }
      });
    },
    onUnload: function() {
      this.$container.off(this.unseroNewsletterNamspace);
    }
  })), e;
})()), (theme.uneroProductTabsSection = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.productTabsId = $(
      "#product-tabs-wrapper-" + i
    )), (this.productTabs = $(
      "#product-tabs-wrapper-" + i
    )), (this.productTabsNamspace =
      "#product-tabs-wrapper-" + i), (this.productTabsShop = $(
      "#product-tabs-wrapper-" + i + " .product-tabs-masonry-2"
    )), (this.productTabsBlog = $(
      "#product-tabs-wrapper-" + i + " .product-tabs-masonry-3"
    )), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {
      this._initTab(), 0 < this.productTabsShop.length &&
        this._initShopLayout(), "1" == this.productTabs.data("animation") &&
        this._animationProduct();
    },
    _initTab: function() {
      $(this.productTabsNamspace + " .product-tabs")
        .off("click")
        .on("click", "ul.tabs li a", function(e) {
          if ((e.preventDefault(), $(this).parent("li").hasClass("active")))
            return !1;
          var t = $(this),
            i = t.closest(".product-tabs"),
            o = i.find("ul.tabs");
          $(t.attr("href")).find("ul.products");
          return o
            .find("li")
            .removeClass(
              "active"
            ), $(this).parent("li").addClass("active"), i.find(".panel:visible").fadeOut(300, function() {
            i.find(t.attr("href")).fadeIn(300, function() {
              $(t.attr("href")).hasClass("product-tabs-masonry-2") &&
                new Isotope(".product-tabs-masonry-2 .products");
            });
          }), !1;
        });
    },
    _initShopLayout: function() {
      var e = this.productTabsShop;
      $(document.body).imagesLoaded(function() {
        e.each(function() {
          $(this)
            .find("ul.products")
            .isotope({ itemSelector: "li.product", layoutMode: "masonry" });
        });
      });
    },
    _animationProduct: function() {
      var e = $(document.body).find(".un-shop-content .product-inner");
      e
        .removeAttr("data-sr-id")
        .removeAttr("style"), (window.sr = new ScrollReveal({
        viewFactor: 0.15,
        duration: 1e3,
        scale: 0.9,
        opacity: 1,
        easing: "ease"
      })), sr.reveal(e, { reset: !0, viewOffset: { top: 64 } });
    },
    onUnload: function() {
      this.$container.off(this.productTabsNamspace);
    }
  })), e;
})()), (theme.unseroStaticBlockSection = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.unseroStaticBlockId = $(
      "#shopify-section-" + i
    )), (this.unseroStaticBlock = $(
      "#static-block-" + i
    )), (this.unseroStaticBlockNamspace = "#static-block-" + i), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {
      0 == this.unseroStaticBlockId.prev().length &&
        ("1" == this.unseroStaticBlock.data("mix_header")
          ? $(document.body).addClass("mix-header")
          : $(document.body).removeClass("mix-header"));
    },
    onUnload: function() {
      this.$container.off(this.unseroStaticBlockNamspace);
    }
  })), e;
})()), (theme.uneroTestimonial = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.uneroTestimonialId = $(
      "#shopify-section-" + i
    )), (this.uneroTestimonial = $(
      "#testimonial-" + i
    )), (this.uneroTestimonialNamspace = "#testimonial-" + i), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {
      this.uneroTestimonial
        .not(".slick-initialized")
        .slick({
          rtl: !1,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplaySpeed: 5e3,
          autoplay: !0,
          infinite: !0,
          lazyLoad: "ondemand",
          prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
          nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>',
          responsive: []
        });
    },
    onUnload: function() {
      this.$container.off(this.uneroTestimonialNamspace);
    }
  })), e;
})()), (theme.YouTubeVideos = (function() {
  function e(e) {
    return n[e.target.h.id];
  }
  function t() {
    $(".home_video_bg").each(function(e, t) {
      !(function(e) {
        var t = e.closest(".home-video"),
          i = e,
          o = t.width(),
          n = (t.height(), i.width()),
          a = i.height();
        o / s.ratio < a
          ? ((n = Math.ceil(a * s.ratio)), e
              .width(n)
              .height(a)
              .css({ left: (o - n) / 2, top: 0 }))
          : ((a = Math.ceil(o / s.ratio)), e
              .width(o)
              .height(a)
              .css({
                left: 0,
                top: (a - a) / 2
              })), t.height(a), e.addClass("home_video_loaded");
      })($(t));
    });
  }
  function i() {
    $(window).on("resize.videoPlayer", $.debounce(250, function() {}));
  }
  var o = !1,
    n = {},
    a = [],
    s = {
      ratio: 16 / 9,
      playerVars: {
        modestbranding: 1,
        autoplay: 1,
        controls: 0,
        showinfo: 0,
        branding: 0,
        rel: 0,
        autohide: 1,
        cc_load_policy: 1,
        disablekb: 0,
        fs: 1,
        iv_load_policy: 3,
        start: 0,
        end: 0,
        loop: 1,
        rel: 0
      },
      events: {
        onReady: function(i) {
          e(i).playerId.addClass("home_video_bg"), i.target.setPlaybackQuality(
            "hd1080"
          ), i.target.mute(), i.target.setLoop(!0), t();
        },
        onStateChange: function(t) {
          var i = e(t);
          switch (t.data) {
            case 0:
              a[i.id].seekTo(i.playerVars.start);
          }
        }
      }
    };
  return {
    init: function(e) {
      if (
        e.id &&
        ((n[e.id] = {
          id: e.id,
          playerId: e.player_id,
          videoId: e.video_id,
          homeVideo: e.home_video,
          videoSelector: e.id,
          playerVars: e.playerDefaults
        }), !o)
      ) {
        var t = document.createElement("script");
        t.src = "https://www.youtube.com/iframe_api";
        var i = document.getElementsByTagName("script")[0];
        i.parentNode.insertBefore(t, i);
      }
    },
    loadVideos: function() {
      for (var e in n)
        if (n.hasOwnProperty(e)) {
          var r = $.extend({}, s, n[e]);
          r.playerId.addClass("home_video_bg"), (a[e] = new YT.Player(e, r));
        }
      t(), i(), (o = !0);
    },
    loadVideo: function(e) {
      if (o) {
        var t = $.extend({}, s, n[e]);
        (a[e] = new YT.Player(e, t)), i();
      }
    }
  };
})()), (theme.uneroVideos = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.videoId = $("#shopify-section-" + i)), (this.videoNamspace =
      "#home-video-" + i), (this.VideoHomeId = $(
      this.videoNamspace
    )), (this.PlayerNamespace = "playerYoutube-" + i), (this.PlayerId = $(
      "#playerYoutube-" + i
    )), (this.VideoHomeWidth = $(
      this.videoNamspace + " .video_width"
    )), (this.options = {
      video_type: this.VideoHomeId.data("video_type")
    }), (this.video_start = this.VideoHomeId.data("video_start"));
    var o = this.VideoHomeId.data("video_duration");
    (this.video_end = parseInt(this.video_start) + parseInt(o)), "yt-video" ==
      this.options.video_type && this._handleYoutubeVideo();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _handleYoutubeVideo: function() {
      var e = {
        id: this.PlayerNamespace,
        video_id: this.PlayerId.data("video_id"),
        home_video: this.VideoHomeId,
        player_id: this.PlayerId,
        playerDefaults: {
          modestbranding: 1,
          autoplay: 1,
          controls: 0,
          showinfo: 0,
          branding: 0,
          rel: 0,
          autohide: 1,
          start: this.video_start,
          end: this.video_end
        }
      };
      (window.home_video_list[e.id] = e), theme.YouTubeVideos.init(
        e
      ), theme.YouTubeVideos.loadVideo(e.id);
    },
    onUnload: function() {
      this.$container.off(this.videoNamspace);
    },
    onSelect: function() {},
    onBlockSelect: function() {},
    onBlockDeselect: function() {}
  })), e;
})()), (theme.uneroBrands = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.brandsId = $("#brands-" + i)), (this.brands = $(
      ".brands-" + i
    )), (this.featuredBrands = $(
      ".featured-brands-" + i
    )), (this.brandsNamspace = "#brands-" + i), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {
      var e = this.featuredBrands.data("perview"),
        t = this.featuredBrands.data("autoplay"),
        i = this.featuredBrands.data("speed");
      this.featuredBrands
        .not(".slick-initialized")
        .slick({
          rtl: !1,
          slidesToShow: e,
          slidesToScroll: 1,
          autoplaySpeed: i,
          autoplay: t,
          infinite: !0,
          lazyLoad: "ondemand",
          prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
          nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>',
          responsive: [
            {
              breakpoint: 1200,
              settings: { slidesToShow: 4, slidesToScroll: 1 }
            },
            {
              breakpoint: 992,
              settings: { slidesToShow: 3, slidesToScroll: 1 }
            },
            {
              breakpoint: 767,
              settings: { slidesToShow: 2, slidesToScroll: 1 }
            }
          ]
        });
    },
    onUnload: function() {
      this.$container.off(this.brandsNamspace);
    }
  })), e;
})()), (theme.gridsSection = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.gridsId = $("#grid-wrapper-" + i)), (this.grids = $(
      "#grid-wrapper-" + i
    )), (this.gridsNamspace = "#grid-wrapper-" + i), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {
      var e = this.sectionId,
        t = (function() {
          function t(e) {
            c.each(function() {
              var t = $(this);
              t.data(
                "offsetTop",
                t.offset().top
              ), e && t.data("height", t.height());
            });
          }
          function i(e) {
            e
              .on("click", "span.og-close", function() {
                return n(), !1;
              })
              .children("a")
              .on("click", function() {
                var e = $(this).parent();
                return l === e.index()
                  ? n()
                  : (function(e) {
                      var t = $.data(this, "preview"), i = e.data("offsetTop");
                      if (((u = 0), void 0 !== t)) {
                        if (d === i) return t.update(e), !1;
                        i > d && (u = t.height), n();
                      }
                      (d = i), (t = $.data(this, "preview", new a(e))).open();
                    })(e), !1;
              });
          }
          function o() {
            s = { width: h.width(), height: h.height() };
          }
          function n() {
            (l = -1), $.data(this, "preview").close(), $.removeData(
              this,
              "preview"
            );
          }
          function a(e) {
            (this.$item = e), (this.expandedIdx = this.$item.index()), this.create(), this.update();
          }
          var s,
            r = $("#og-grid-" + e),
            c = r.children("li"),
            l = -1,
            d = -1,
            u = 0,
            h = $(window),
            p = $("html, body"),
            f = {
              WebkitTransition: "webkitTransitionEnd",
              MozTransition: "transitionend",
              OTransition: "oTransitionEnd",
              msTransition: "MSTransitionEnd",
              transition: "transitionend"
            }[Modernizr.prefixed("transition")],
            m = Modernizr.csstransitions,
            g = { minHeight: 500, speed: 350, easing: "ease" };
          return (a.prototype = {
            create: function() {
              (this.$title = $("<h3></h3>")), (this.$description = $(
                "<p></p>"
              )), (this.$href = $(
                '<a class="button" href="#"><span></span></a>'
              )), (this.$details = $('<div class="og-details"></div>').append(
                this.$title,
                this.$description,
                this.$href
              )), (this.$loading = $(
                '<div class="og-loading"></div>'
              )), (this.$fullimage = $('<div class="og-fullimg"></div>').append(
                this.$loading
              )), (this.$closePreview = $(
                '<span class="og-close"></span>'
              )), (this.$previewInner = $(
                '<div class="og-expander-inner"></div>'
              ).append(
                this.$closePreview,
                this.$fullimage,
                this.$details
              )), (this.$previewEl = $(
                '<div class="og-expander"></div>'
              ).append(this.$previewInner)), this.$item.append(
                this.getEl()
              ), m && this.setTransition();
            },
            update: function(e) {
              (e && (this.$item = e), -1 != l) &&
                (c.eq(l).removeClass("og-expanded"), this.$item.addClass(
                  "og-expanded"
                ), this.positionPreview());
              l = this.$item.index();
              var t = this.$item.children("a"),
                i = {
                  href: t.attr("href"),
                  largesrc: t.data("largesrc"),
                  title: t.data("title"),
                  cta: t.data("cta"),
                  description: t.data("description")
                };
              this.$title.html(i.title), this.$description.html(
                i.description
              ), this.$href.html("<span>" + i.cta + "</span>"), this.$href.attr(
                "href",
                i.href
              );
              var o = this;
              void 0 !== o.$largeImg && o.$largeImg.remove(), o.$fullimage.is(
                ":visible"
              ) &&
                (this.$loading.show(), $("<img/>")
                  .load(function() {
                    var e = $(this);
                    e.attr("src") === o.$item.children("a").data("largesrc") &&
                      (o.$loading.hide(), o.$fullimage
                        .find("img")
                        .remove(), (o.$largeImg = e.fadeIn(
                        350
                      )), o.$fullimage.append(o.$largeImg));
                  })
                  .attr("src", i.largesrc));
            },
            open: function() {
              setTimeout(
                $.proxy(function() {
                  this.setHeights(), this.positionPreview();
                }, this),
                25
              );
            },
            close: function() {
              var e = this,
                t = function() {
                  m && $(this).off(f), e.$item.removeClass(
                    "og-expanded"
                  ), e.$previewEl.remove();
                };
              return setTimeout(
                $.proxy(function() {
                  void 0 !== this.$largeImg &&
                    this.$largeImg.fadeOut(
                      "fast"
                    ), this.$previewEl.css("height", 0);
                  var e = c.eq(this.expandedIdx);
                  e.css("height", e.data("height")).on(f, t), m || t.call();
                }, this),
                25
              ), !1;
            },
            calcHeight: function() {
              var e = s.height - this.$item.data("height") - 10, t = s.height;
              e < g.minHeight &&
                ((e = g.minHeight), (t =
                  g.minHeight +
                  this.$item.data("height") +
                  10)), (this.height = e), (this.itemHeight = t);
            },
            setHeights: function() {
              var e = this,
                t = function() {
                  m && e.$item.off(f), e.$item.addClass("og-expanded");
                };
              this.calcHeight(), this.$previewEl.css(
                "height",
                this.height
              ), this.$item.css("height", this.itemHeight).on(f, t), m ||
                t.call();
            },
            positionPreview: function() {
              var e = this.$item.data("offsetTop"),
                t = this.$previewEl.offset().top - u,
                i = this.height + this.$item.data("height") + 10 <= s.height
                  ? e
                  : this.height < s.height ? t - (s.height - this.height) : t;
              p.animate({ scrollTop: i }, g.speed);
            },
            setTransition: function() {
              this.$previewEl.css(
                "transition",
                "height " + g.speed + "ms " + g.easing
              ), this.$item.css(
                "transition",
                "height " + g.speed + "ms " + g.easing
              );
            },
            getEl: function() {
              return this.$previewEl;
            }
          }), {
            init: function(e) {
              (g = $.extend(!0, {}, g, e)), r.imagesLoaded(function() {
                t(!0), o(), i(c), h.on("debouncedresize", function() {
                  (u = 0), (d = -1), t(), o(), void 0 !== $.data(this, "preview") && n();
                });
              });
            },
            addItems: function(e) {
              (c = c.add(e)), e.each(function() {
                var e = $(this);
                e.data({ offsetTop: e.offset().top, height: e.height() });
              }), i(e);
            }
          };
        })();
      $(function() {
        t.init();
      });
    },
    onUnload: function() {
      this.$container.off(this.gridsNamspace);
    }
  })), e;
})()), (theme.CollectionCarouselTemplate = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.CollectionId = $("#collection-" + i)), (this.Collection = $(
      "#collection-" + i
    )), (this.CollectionNamspace = "#collection-" + i), (this.carouselSlide = $(
      ".unero-products-carousel-" + i
    )), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {
      0 < this.carouselSlide.length &&
        this.carouselSlide.each(function() {
          var e = $(this),
            t = $(this).data("per_view"),
            i = $(this).data("autoplay"),
            o = $(this).data("speed"),
            n = !1;
          "1" == i &&
            (n = !0), e.find(".unero-products-carousel-slide").not(".slick-initialized").slick({ rtl: !1, slidesToShow: t, slidesToScroll: 1, autoplaySpeed: o, autoplay: i, infinite: n, lazyLoad: "ondemand", prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>', nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>', responsive: [{ breakpoint: 1200, settings: { slidesToShow: 3, slidesToScroll: 1 } }, { breakpoint: 767, settings: { slidesToShow: 2, slidesToScroll: 1 } }] });
        });
    },
    onUnload: function() {
      this.$container.off(this.CollectionNamspace);
    }
  })), e;
})()), (theme.ProductVariantMobile = (function() {
  function e(e) {
    var t = (this.$container = $(e)),
      i = (this.sectionId = t.attr("data-section-id"));
    t.attr("data-section-type");
    (this.wrapperId = $("#" + i)), (this.wrapper = $(
      "#" + i
    )), (this.wrapperNamspace = "#" + i), (this.addCartId = $(
      "#btn-" + i + ".m-allow-cart"
    )), (this.addCartClass = $(
      ".variant-item-" + i + ".m-allow-cart"
    )), this._init();
  }
  return (e.prototype = _.assignIn({}, e.prototype, {
    _init: function() {
      var e = this;
      e._initCompact(), e._initEvents(), $(window).resize(function() {
        767 >= $(window).width() && e._initCompact();
      });
    },
    _initCompact: function() {
      if (0 < $(".product-variant-mobile-section").length) {
        var e = $(".product-variant-mobile-section"),
          t = $(".product-variants-mobile");
        t.each(function() {
          var e = $(this),
            t = e.find(".variants-header"),
            i = t.innerHeight(),
            o = e.find(".variants-content").outerHeight();
          t.closest(".product-variants-mobile");
          t.data("height", i), e.data("height", i + o);
        }), t.each(function() {
          var e = $(this),
            t = e.find(".variants-header"),
            i = t.innerHeight(),
            o = e.find(".variants-content").outerHeight(),
            n = t.closest(".product-variants-mobile");
          t.data(
            "height",
            i
          ), e.data("height", i + o), n.hasClass("active") && n.height(n.data("height"));
        }), e.unbind("click") &&
          e.on("click", ".variants-header .title", function() {
            var e = $(this),
              i = e.closest(".variants-header"),
              o = e.closest(".product-variants-mobile");
            o.hasClass("active") ||
              t
                .closest(".active")
                .removeClass("active")
                .height(
                  e.data("height")
                ), o.toggleClass("active"), o.hasClass("active") ? o.height(o.data("height")) : o.height(i.data("height"));
          });
      }
    },
    _initEvents: function() {
      var e = $("#ProductSelect-product-template.variation-select").val();
      0 < this.addCartId.length &&
        (this.addCartId.unbind("click"), this.addCartId.on("click", function() {
          $("#ProductSelect-product-template.variation-select").val(
            e
          ), $("#AddToCart-product-template").trigger("click");
        })), 0 < this.addCartClass.length &&
        (this.addCartClass.unbind(
          "click"
        ), this.addCartClass.on("click", function() {
          var e = $(this).data("id");
          $("#ProductSelect-product-template.variation-select").val(
            e
          ), $("#AddToCart-product-template").trigger("click");
        }));
    },
    onUnload: function() {
      this.$container.off(this.wrapperNamspace);
    }
  })), e;
})()), $(document).ready(function() {
  var e = new theme.Sections();
  e.register(
    "product-template",
    theme.Product
  ), e.register("product-template-variant", theme.Product), e.register("product-variant-mobile", theme.ProductVariantMobile), e.register("cart-template", theme.Cart), e.register("search-template", theme.SearchTemplate), e.register("blog-template", theme.BlogTemplate), e.register("article-template", theme.ArticleTemplate), e.register("collection-template", theme.CollectionTemplate), e.register("collection-carousel-template", theme.CollectionCarouselTemplate), e.register("collections-template", theme.CollectionsTemplate), e.register("portfolio-masonry-template", theme.portfolioMasonry), e.register("collection-instagram-template", theme.CollectionInstagramTemplate), e.register("faqs-template", theme.faqsTemplate), e.register("contact-template", theme.Maps), e.register("about-template", theme.aboutTemplate), e.register("footer-section", theme.footerSection), e.register("menu-sidebar-section", theme.sideBarSection), e.register("mobile-nav-section", theme.mobileNavSection), e.register("header-section", theme.HeaderSection), e.register("totop-section", theme.toTopSection), e.register("header-slider", theme.SliderSection), e.register("unero-slider-section", theme.uneroSliderSection), e.register("unero-hero-slider-section", theme.uneroHeroSliderSection), e.register("unero-collections-section", theme.uneroCollectionsSection), e.register("unero-collections-masonry-section", theme.uneroCollectionsMasonrySection), e.register("unero-featured-collections-section", theme.uneroProductsCarouselSection), e.register("unero-product-tabs-section", theme.uneroProductTabsSection), e.register("unero-about-section", theme.uneroAboutSection), e.register("unero-banner-grid-section", theme.uneroBannerSection), e.register("unero-banner-metro-section", theme.uneroBannerMetroSection), e.register("unero-instagram-section", theme.uneroInstagramSection), e.register("unero-blog-section", theme.unseroBlogSection), e.register("unero-newsletter-section", theme.unseroNewsletterSection), e.register("unero-static-block", theme.unseroStaticBlockSection), e.register("unero-testimonial-section", theme.uneroTestimonial), e.register("unero-video-section", theme.uneroVideos), e.register("unero-brand-section", theme.uneroBrands), e.register("slideshow-section", theme.SlideshowSection), e.register("products", theme.Products), e.register("blog", theme.Blog), e.register("collections", theme.Collections), e.register("grid-view", theme.gridsSection);
}), (window.theme = theme || {}), (theme.roarApplication = (function() {
  function e() {
    "undefined" != typeof SPR &&
      (SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges());
  }
  function t() {
    $.ajax({
      url: "/search",
      beforeSend: function() {
        $("#cart-panel").addClass("loading");
      },
      success: function(e) {
        var t = "#icon-cart-contents .mini-cart-counter", i = "div#cart-panel";
        $(t).html($(e).find(t).html()), $(i).html(
          $(e).filter(i).html()
        ), theme.CurrencyPicker.convert("#cart-panel .money");
      },
      error: function(e) {
        console.log(e);
      }
    }).done(function() {
      $("#cart-panel").removeClass("loading");
    });
  }
  function i(e) {
    $(document.body).addClass("modal-open"), e.fadeIn(), e.addClass("open");
  }
  function o() {
    $(document.body).removeClass("modal-open"), $(
      ".unero-modal"
    ).fadeOut(function() {
      $(document.body)
        .find("#menu-extra-search, #menu-extra-login")
        .removeClass("show"), $(this).removeClass("open");
    });
  }
  function n() {
    0 < $(".add_to_cart_variant_button").length &&
      $(".add_to_cart_variant_button").unbind("click"), $(
      document
    ).on("click", ".add_to_cart_variant_button", function() {
      var e = $(this);
      return e.hasClass("disabled")
        ? alert(theme.strings.alert_variant)
        : ((Shopify.queue = []), jQuery(".qty-variant").each(function() {
            Shopify.queue.push({
              variantId: jQuery(this).data("variant_id"),
              quantity: parseInt(jQuery(this).val(), 10) || 0
            });
          }), (Shopify.moveAlong = function() {
            if (Shopify.queue.length) {
              var i = Shopify.queue.shift();
              $.ajax({
                type: "POST",
                url: "/cart/add.js",
                async: !0,
                cache: !1,
                data: { quantity: i.quantity, id: i.variantId },
                dataType: "json",
                beforeSend: function() {
                  e.addClass("loading");
                },
                complete: function() {
                  t();
                },
                error: function(e) {
                  var t = $.parseJSON(e.responseText),
                    i = t.message + ": " + t.description;
                  alert(i);
                },
                success: function() {
                  Shopify.moveAlong();
                }
              });
            } else
              "" == theme.cart_ajax
                ? (window.location.href = "/cart")
                : (e.removeClass("loading"), o(), $(document.body).toggleClass(
                    "display-cart"
                  ), l($("#cart-panel")));
          }), Shopify.moveAlong()), !1;
    }), $(document).on("click", ".add_to_cart_button", function() {
      var e = $(this), i = e.closest("form");
      return "" == theme.cart_ajax
        ? (i.submit(), !1)
        : ($.ajax({
            type: "POST",
            url: "/cart/add.js",
            async: !0,
            cache: !1,
            data: i.serialize(),
            dataType: "json",
            beforeSend: function() {
              e.addClass("loading");
            },
            complete: function() {
              t();
            },
            error: function(t) {
              var i = $.parseJSON(t.responseText),
                o = i.message + ": " + i.description;
              e.removeClass("loading"), alert(o);
            },
            success: function() {}
          }).done(function() {
            e.removeClass(
              "loading"
            ), o(), $(document.body).toggleClass("display-cart"), l($("#cart-panel"));
          }), !1);
    }), $(document).on("click", "#cart-panel .remove", function(e) {
      e.preventDefault();
      var i = $(this), o = i.attr("data-id");
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&id=" + o,
        dataType: "json",
        beforeSend: function() {
          i.closest("#cart-panel").addClass("loading");
        },
        success: function() {
          t();
        },
        error: function(e, t) {
          Shopify.onError(e, t);
        }
      });
    }), $(document)
      .on("focus", "#cart-panel .update", function() {
        $(this).select();
      })
      .on("blur", "#cart-panel .update", function() {
        var e = $(this), i = e.val(), o = e.attr("data-id");
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: "quantity=" + i + "&id=" + o,
          dataType: "json",
          beforeSend: function() {
            $("#cart-panel").addClass("loading");
          },
          success: function() {
            t();
          },
          error: function(e, t) {
            Shopify.onError(e, t);
          }
        });
      }), $(
      document.body
    ).on("click", ".product-quick-view, .un-product-link", function(t) {
      t.preventDefault();
      var o = $(this),
        n = o.attr("href"),
        a = $("#quick-view-modal"),
        s = a.find(".container"),
        r = (a.find(".modal-header .close-modal").first().clone(), $(this).data(
          "ptnamespace"
        ));
      o.addClass(
        "loading"
      ), s.hide().html("").addClass("invisible"), a.addClass("loading"), i(a), $.get(
        n,
        function(t) {
          s.html($(t)), a.removeClass("loading"), o.removeClass(
            "loading"
          ), s
            .show()
            .removeClass("invisible"), c(), e(), new theme.Sections().register(
            r,
            theme.Product
          ), theme.CurrencyPicker.convert("#ProductSection-" + r + " .money");
        },
        "html"
      );
    }), $("#quick-view-modal").on("click", function(e) {
      var t = e.target;
      0 >= $(t).closest("div.product").length && o();
    });
  }
  function a() {
    jQuery("#be_compare_features_table").on("scroll", function() {
      var e = jQuery(this).parent();
      jQuery(this).scrollLeft() + jQuery(this).innerWidth() >=
        jQuery(this)[0].scrollWidth
        ? e.hasClass("scroll-right") && e.removeClass("scroll-right")
        : 0 === jQuery(this).scrollLeft()
            ? e.hasClass("scroll-left") && e.removeClass("scroll-left")
            : (!e.hasClass("scroll-right") &&
                e.addClass("scroll-right"), !e.hasClass("scroll-left") &&
                e.addClass("scroll-left"));
    }), (be_compare_container = document.getElementById(
      "be_compare_features_table"
    )), null !== be_compare_container &&
      be_compare_container.offsetWidth < be_compare_container.scrollWidth &&
      !jQuery("#be_compare_features_table_inner").hasClass("scroll-right") &&
      jQuery("#be_compare_features_table_inner").addClass(
        "scroll-right"
      ), jQuery(window).on("resize", function() {
      (be_compare_container = document.getElementById(
        "be_compare_features_table"
      )), null === be_compare_container || (be_compare_container.offsetWidth < be_compare_container.scrollWidth ? !jQuery("#be_compare_features_table_inner").hasClass("scroll-right") && jQuery("#be_compare_features_table_inner").addClass("scroll-right") : (jQuery("#be_compare_features_table_inner").hasClass("scroll-right") && jQuery("#be_compare_features_table_inner").removeClass("scroll-right"), jQuery("#be_compare_features_table_inner").hasClass("scroll-left") && jQuery("#be_compare_features_table_inner").removeClass("scroll-left")), jQuery("#be_compare_features_table_inner").hasClass("scroll-left") || jQuery("#be_compare_features_table_inner").hasClass("scroll-right") ? $(".compare-preview").addClass("no-flex") : $(".compare-preview").removeClass("no-flex"));
    }), jQuery("#be_compare_features_table_inner").hasClass("scroll-left") ||
      jQuery("#be_compare_features_table_inner").hasClass("scroll-right")
      ? $(".compare-preview").addClass("no-flex")
      : $(".compare-preview").removeClass("no-flex");
  }
  function s() {
    var t, i, o;
    "1" == theme.compare &&
      ((t = $("body")), $("a.add_to_compare"), (i =
        ""), (o = !1), t.on("click", "a.add_to_compare", function() {
        var t = $(this),
          n = t.data("pid"),
          s = Currency.cookie.rtread("rt-compare"),
          r = !1;
        if (
          ((o = !1), t.addClass("loading"), (s = null != s && "" != s
            ? s.split(",")
            : []), t.hasClass("reach-limit") &&
            ((o = !0), !1 === $(this).hasClass("added") &&
              ((r = !0), jQuery("#rtp-message").html(
                theme.strings.c_msg
              ), jQuery("#rt-unero-popup-message")
                .css(
                  "margin-left",
                  "-" +
                    parseFloat(jQuery("#rt-unero-popup-message").width()) / 2 +
                    "px"
                )
                .fadeIn(), window.setTimeout(function() {
                jQuery("#rt-unero-popup-message").fadeOut();
              }, 2e3))), 0 > s.indexOf(n) &&
            !1 === $(this).hasClass("added") &&
            0 == o)
        ) {
          s.push(n);
          var c = s.join(",");
          "," == c.substring(0, 1) &&
            (c = c.substring(1)), Currency.cookie.rtwrite("rt-compare", c);
        }
        !1 === $(this).hasClass("added") || "" == i
          ? ((i = ""), $.ajax({
              url: "/search?view=compare&q=" + s,
              dataType: "html",
              type: "GET",
              success: function(e) {
                i = e;
              },
              error: function() {
                console.log("ajax error"), t.removeClass("loading");
              },
              complete: function() {
                s.length >= parseInt(theme.compare_limit) &&
                  0 < $("a.add_to_compare").length &&
                  $("a.add_to_compare").each(function() {
                    $(this).addClass("reach-limit");
                  }), $.magnificPopup.open({
                  items: { src: i, type: "inline" },
                  preloader: !0,
                  tLoading: "",
                  mainClass: "compare-preview",
                  removalDelay: 200,
                  gallery: { enabled: !0 },
                  callbacks: {
                    open: function() {
                      0 == r &&
                        ($('[data-pid="' + n + '"]')
                          .addClass("added")
                          .attr(
                            "data-original-title",
                            $('[data-pid="' + n + '"]').attr("data-added")
                          ), $('[data-pid="' + n + '"]')
                          .find("span")
                          .html(
                            $('[data-pid="' + n + '"]').attr("data-added")
                          )), t.removeClass(
                        "loading"
                      ), theme.CurrencyPicker.convert(
                        ".compare-content .money"
                      ), e(), a();
                    }
                  }
                });
              }
            }))
          : $.ajax({
              url: "/search?view=compare&q=" + s,
              dataType: "html",
              type: "GET",
              success: function(e) {
                i = e;
              },
              error: function() {
                console.log("ajax error"), t.removeClass("loading");
              },
              complete: function() {
                $.magnificPopup.open({
                  items: { src: i, type: "inline" },
                  preloader: !0,
                  tLoading: "",
                  mainClass: "compare-preview",
                  removalDelay: 200,
                  gallery: { enabled: !0 },
                  callbacks: {
                    open: function() {
                      t.removeClass("loading"), theme.CurrencyPicker.convert(
                        ".compare-content .money"
                      ), e(), a();
                    }
                  }
                });
              }
            });
      }), t.on("click", ".remove_from_compare", function(e) {
        e.preventDefault();
        var t = $(this).attr("data-rev");
        $(
          ".compare-content"
        ), $('[data-pid="' + t + '"]').removeClass("added").attr("data-original-title", $('[data-pid="' + t + '"]').attr("data-title")), $('[data-pid="' + t + '"]').find("span").html($('[data-pid="' + t + '"]').attr("data-title"));
        var i = decodeURI(Currency.cookie.rtread("rt-compare"));
        null != i &&
          (i = i.split(",")).length <= theme.compare_limit &&
          0 < $("a.add_to_compare").length &&
          $("a.add_to_compare").each(function() {
            $(this).removeClass("reach-limit");
          }), (i = jQuery.grep(i, function(e) {
          return e != t;
        })), (i = $.trim(
          i
        )), Currency.cookie.rtwrite("rt-compare", i), a(), $(".unero_" + t).remove(), 0 >= i.length && $(".mfp-close").trigger("click");
      }), (function() {
        if (0 != parseInt(theme.compare)) {
          var e = Currency.cookie.rtread("rt-compare");
          null == e
            ? (e = [])
            : ((e = e.split(",")).length >= parseInt(theme.compare_limit) &&
                $(".add_to_compare").addClass("reach-limit"), e.map(function(
                e
              ) {
                $('[data-pid="' + e + '"]')
                  .addClass("added")
                  .attr(
                    "data-original-title",
                    $('[data-pid="' + e + '"]').attr("data-added")
                  ), $('[data-pid="' + e + '"]')
                  .find("span")
                  .html($('[data-pid="' + e + '"]').attr("data-added"));
              }));
        }
      })(), a());
  }
  function r() {
    $(document.body).find("img.lazy").lazyload({ threshold: 1e3 });
  }
  function c() {
    $(".add_to_wishlist")
      .attr("data-original-title", $(".add_to_wishlist").html())
      .attr("rel", "tooltip"), $("[rel=tooltip]").tooltip({ offsetTop: -15 });
  }
  function l(e) {
    $(document.body).addClass("open-canvas-panel"), e.addClass("open");
  }
  function d() {
    $(document.body).removeClass("open-canvas-panel"), $(
      ".unero-off-canvas-panel, #primary-mobile-nav, #primary-offcanvas-wrapper"
    ).removeClass("open");
  }
  function u() {
    0 < $(".un-attr-swatches").length &&
      $(".un-attr-swatches").each(function() {
        1 == $(this).find(".swatch").length && $(this).addClass("hide");
      }), $(".un-swatch-variation-image").click(function() {
      $(this).hasClass("selected") ||
        ("" != $(this).attr("data-src") &&
          $(this)
            .closest(".product-inner")
            .find(".product-item-image")
            .attr("src", $(this).attr("data-src"))
            .attr("srcset", $(this).attr("data-srcset")), $(this)
          .closest(".un-attr-swatches")
          .find(".un-swatch-variation-image")
          .removeClass("selected"), $(this).addClass("selected"));
    });
  }
  function h() {
    $(document.body).hasClass("catalog-board-content") &&
      $(document.body).imagesLoaded(function() {
        $("#un-shop-content")
          .find("ul.products")
          .isotope({ itemSelector: "li.product", layoutMode: "masonry" });
      });
  }
  function p() {
    $(document.body).hasClass("collection-metro-content") &&
      $(document.body).imagesLoaded(function() {
        $("#un-shop-content")
          .find("ul.products")
          .isotope({ itemSelector: "li.product", layoutMode: "masonry" });
      });
  }
  function f() {
    $("#unero-site-content").hasClass("blog-layout-masonry") &&
      $(document.body).imagesLoaded(function() {
        $("#unero-site-content")
          .find(".unero-post-list")
          .isotope({ itemSelector: ".un-post-item", layoutMode: "masonry" });
      });
  }
  function m() {
    if ($("#content").hasClass("animation-product")) {
      var e = $(document.body).find("#un-shop-content .product-inner");
      e
        .removeAttr("data-sr-id")
        .removeAttr("style"), (window.sr = new ScrollReveal({
        viewFactor: 0.15,
        duration: 1e3,
        scale: 0.9,
        opacity: 1,
        easing: "ease"
      })), sr.reveal(e, { reset: !0, viewOffset: { top: 64 } });
    }
  }
  function g() {
    if ($(".page-header").hasClass("page-header-sliders")) {
      var e = $(".page-header-sliders"),
        t = e.data("speed"),
        i = !1,
        o = e.data("auto"),
        n = e.data("parallax");
      if (
        ("1" == n && (i = !0), e
          .find("ul")
          .not(".slick-initialized")
          .slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: !0,
            autoplaySpeed: t,
            autoplay: o,
            fade: i,
            cssEase: "linear",
            prevArrow: '<span class="icon-chevron-left slick-prev-arrow"></span>',
            nextArrow: '<span class="icon-chevron-right slick-next-arrow"></span>'
          }), "0" == n)
      )
        $(".page-header-sliders.parallax").find("li").parallax("50%", 0.6);
      else {
        var a = e.height();
        $(document.body).hasClass("admin-bar") && (a -= 32), $("#content").css(
          "margin-top",
          a
        ), e.addClass("parallax-2"), $(window).on("scroll", function() {
          var e = $(window).scrollTop();
          0 < e
            ? $(".page-header-sliders.parallax-2").css({ opacity: (a - e) / a })
            : $(".page-header-sliders.parallax-2").css({ opacity: 1 });
        });
      }
    } else $(".page-header.parallax").parallax("50%", 0.6);
  }
  function v() {
    $().countdown &&
      0 < $(".countdown-item:not(.is-countdown)").length &&
      $(".countdown-item:not(.is-countdown)").each(function() {
        if ("" != $(this).data("countdown")) {
          var e = new Date(), t = $(this).data("countdown").split("-");
          e < (t = new Date(t[2], parseInt(t[0]) - 1, t[1])) &&
            $(this).countdown({
              until: t,
              layout: '<span class="countdown-day">{dn}d</span><span class="countdown-hour">{hn}h</span><span class="countdown-minute">{mn}m</span><span class="countdown-second">{sn}s</span>'
            });
        }
      });
  }
  function y() {
    $(".more-details-btn").on("click", function(e) {
      e.preventDefault(), $(this).closest(".hover-content").addClass("show-full-description");
      var t = $(this).closest(".unero-fade-in-block").height() + 15;
      $(this)
        .closest(".product-item-details")
        .find(".unero-product-item-imagin")
        .css("margin-bottom", "-" + t + "px");
    });
  }
  return {
    init: function() {
      var t, a, w, _, b, C;
      (t = $("#un-shop-toolbar")), (a = $("#un-shop-topbar")), (w = $(
        "#un-categories-filter"
      )), (_ = t.find(".rt-unero-ordering")), (b = $(
        ".catalog-sidebar"
      )), (C = $(".catalog-offcanvas")), $(window)
        .on("resize", function() {
          991 > $(window).width()
            ? (t.addClass("on-mobile"), a.addClass("on-mobile"), b.addClass(
                "on-mobile"
              ), C.addClass("on-mobile"))
            : (w.removeAttr("style"), $("#un-toggle-cats-filter").removeClass(
                "active"
              ), t.removeClass("on-mobile"), a.removeClass(
                "on-mobile"
              ), b.removeClass("on-mobile"), C.removeClass("on-mobile"), a
                .find(".widget-title")
                .next()
                .removeAttr("style"), b
                .find(".widget-title")
                .next()
                .removeAttr("style"));
        })
        .trigger("resize"), $(document.body)
        .find(".shop-toolbar, .shop-bottombar")
        .on("click", ".un-filter.filter-canvas", function(e) {
          e.preventDefault(), $("#primary-offcanvas-wrapper").toggleClass("open"), $(document.body).toggleClass("open-canvas-panel"), $(
            this
          )
            .closest(".shop-toolbar")
            .hasClass("on-mobile") &&
            (w.slideUp(200), _.slideUp(200), $(
              "#un-toggle-cats-filter"
            ).removeClass("active"), $("#un-ordering").removeClass(
              "active"
            ), setTimeout(function() {
              a.slideToggle(200);
            }, 200)), $(document.body).toggleClass("show-filters-content");
        }), 0 < $("#primary-offcanvas-wrapper").length &&
        $(
          "#primary-offcanvas-wrapper"
        ).on("click", ".close-canvas-shop-panel", function(e) {
          e.preventDefault(), d();
        }), $(document.body)
        .find(".shop-toolbar, .shop-bottombar")
        .on("click", ".un-filter:not(.filter-canvas)", function(e) {
          e.preventDefault(), $(this)
            .closest(".shop-toolbar")
            .hasClass("on-mobile")
            ? (w.slideUp(200), _.slideUp(200), $(
                "#un-toggle-cats-filter"
              ).removeClass("active"), $("#un-ordering").removeClass(
                "active"
              ), setTimeout(function() {
                a.slideToggle(200);
              }, 200))
            : a.slideToggle(), a.toggleClass("active"), $(this).toggleClass("active"), a.closest(".shop-bottombar").toggleClass("show"), $("#un-filter-overlay").toggleClass("show"), $(document.body).toggleClass("show-filters-content");
        }), $(document.body).on("click", "#un-filter-overlay", function(e) {
        e.preventDefault(), a.slideToggle(), $(".un-filter").removeClass("active"), a.closest(".shop-bottombar").toggleClass("show"), $("#un-filter-overlay").toggleClass("show"), a.removeClass("active"), $(document.body).removeClass("show-filters-content");
      }), $(document.body).on("click", "#un-toggle-cats-filter", function(e) {
        e.preventDefault(), $(this)
          .closest(".shop-toolbar")
          .hasClass("on-mobile") &&
          (a.slideUp(200), setTimeout(function() {
            w.slideToggle(200);
          }, 200), $(this).toggleClass("active"), $(".un-filter").removeClass(
            "active"
          ), a.removeClass("active"));
      }), $(document.body).on("click", "#un-ordering", function(e) {
        e.preventDefault(), $(this)
          .closest(".shop-toolbar")
          .hasClass("on-mobile") &&
          (a.slideUp(200), setTimeout(function() {
            _.slideToggle(200);
          }, 200), $(this).toggleClass("active"), $(".un-filter").removeClass(
            "active"
          ), a.removeClass("active"));
      }), a.on("click", ".widget-title", function(e) {
        $(this).closest(".shop-topbar").hasClass("on-mobile") &&
          (e.preventDefault(), $(this)
            .closest(".widget")
            .siblings()
            .find(".widget-title")
            .next()
            .slideUp(200), $(this)
            .closest(".widget")
            .siblings()
            .removeClass("active"), $(this).next().slideToggle(200), $(this)
            .closest(".widget")
            .toggleClass("active"));
      }), b.on("click", ".widget-title", function(e) {
        $(this).closest(".catalog-sidebar").hasClass("on-mobile") &&
          (e.preventDefault(), $(this)
            .closest(".widget")
            .siblings()
            .find(".widget-title")
            .next()
            .slideUp(200), $(this)
            .closest(".widget")
            .siblings()
            .removeClass("active"), $(this).next().slideToggle(200), $(this)
            .closest(".widget")
            .toggleClass("active"));
      }), C.on("click", ".widget-title", function(e) {
        $(this).closest(".catalog-offcanvas").hasClass("on-mobile") &&
          (e.preventDefault(), $(this)
            .closest(".widget")
            .siblings()
            .find(".widget-title")
            .next()
            .slideUp(200), $(this)
            .closest(".widget")
            .siblings()
            .removeClass("active"), $(this).next().slideToggle(200), $(this)
            .closest(".widget")
            .toggleClass("active"));
      }), $(document.body).on("click", ".un-shop-view", function(e) {
        e.preventDefault();
        var t = $(this), i = t.data("view");
        t.hasClass("current") ||
          ($(document.body)
            .find(".un-shop-view")
            .removeClass("current"), t.addClass("current"), $(document.body)
            .removeClass("shop-view-grid shop-view-list")
            .addClass("shop-view-" + i), $(document.body).trigger(
            "unero_shop_view_after_change"
          ));
      }), $(document.body).on("unero_shop_view_after_change", function() {
        r();
      }), r(), c(), $(
        document
      ).on("click", ".add_to_wishlist:not(.added)", function(e) {
        if (!$(this).hasClass("need-login")) {
          e.preventDefault();
          var t = $(this),
            i = t.data("product_id"),
            o = { action: "add_wishlist" };
          return (o =
            t.closest("form").serialize() + "&" + $.param(o)), $.ajax({
            type: "POST",
            url: "/a/wishlist",
            async: !0,
            cache: !1,
            data: o,
            dataType: "json",
            beforeSend: function() {
              t.addClass("loading"), t
                .attr("data-original-title", t.attr("data-loading-text"))
                .tooltip("fixTitle")
                .tooltip("show");
            },
            error: function(e) {
              console.log(e);
            },
            complete: function() {
              t
                .attr("data-original-title", t.attr("data-added"))
                .tooltip("fixTitle")
                .tooltip("show"), t.attr(
                "data-original-title",
                t.attr("data-success")
              ), t.addClass("added"), $(".wishlist" + i).addClass("added"), $(
                ".wishlist" + i
              ).attr(
                "data-original-title",
                t.attr("data-success")
              ), setTimeout(function() {
                t.tooltip("hide");
              }, 500);
            },
            success: function(e) {
              t.removeClass("loading"), $(".wishlist" + i + " > span").html(
                $(".wishlist" + i).attr("data-success")
              ), $(".wishlist" + t.prev().val()), 0 <
                $(".menu-item-wishlist .mini-cart-counter").length &&
                $(".menu-item-wishlist .mini-cart-counter").html(
                  parseInt($(".menu-item-wishlist .mini-cart-counter").html()) +
                    1
                ), 1 == e.code
                ? ($(".wishlist_items_number").text(e.json), jQuery(
                    "#rtp-message"
                  ).html(t.attr("data-added")), jQuery(
                    "#rt-unero-popup-message"
                  )
                    .css(
                      "margin-left",
                      "-" +
                        parseFloat(jQuery("#rt-unero-popup-message").width()) /
                          2 +
                        "px"
                    )
                    .fadeIn(), window.setTimeout(function() {
                    jQuery("#rt-unero-popup-message").fadeOut();
                  }, 2e3))
                : (alert(e.json), console.log(e.json));
            }
          }), !1;
        }
      }), $(document).on("click", ".remove_from_wishlist", function(e) {
        e.preventDefault();
        var t = $(this), i = { action: "remove_wishlist" };
        return (i = t.closest("form").serialize() + "&" + $.param(i)), $.ajax({
          type: "POST",
          url: "/a/wishlist",
          async: !0,
          cache: !1,
          data: i,
          dataType: "json",
          beforeSend: function() {
            $(".page-wishlist-content").addClass("loading");
          },
          error: function(e) {
            console.log(e), $(".page-wishlist-content").removeClass("loading");
          },
          success: function(e) {
            1 == e.code
              ? t.closest("tr").slideUp("fast", function() {
                  t
                    .closest("tr")
                    .remove(), $(".page-wishlist-content .infos").removeClass("hide"), $(".wishlist_items_number").text(e.json), 0 == e.json && $(".wishlist-empty").removeClass("hide");
                })
              : (alert(e.json), console.log(e.json)), $(
              ".page-wishlist-content"
            ).removeClass("loading"), 0 <
              $(".menu-item-wishlist .mini-cart-counter").length &&
              $(".menu-item-wishlist .mini-cart-counter").html(
                parseInt($(".menu-item-wishlist .mini-cart-counter").html()) - 1
              );
          }
        }), !1;
      }), e(), v(), u(), n(), $(
        document.body
      ).on("click", "#menu-extra-search", function(e) {
        e.preventDefault(), i($("#search-modal")), $(this).addClass("show");
      }), $(document.body).on("click", ".close-modal", function(e) {
        e.preventDefault(), o();
      }), $(document.body).on("click", ".cart-contents", function(e) {
        e.preventDefault(), l($("#cart-panel"));
      }), $(document.body).on("click", "#icon-menu-sidebar", function(e) {
        e.preventDefault(), l($("#menu-sidebar-menu-sidebar"));
      }), $(
        document.body
      ).on("click", "#off-canvas-layer, .close-canvas-panel", function(e) {
        e.preventDefault(), d();
      }), m(), h(), p(), f(), (function() {
        if ($(document.body).hasClass("portfolio-layout-carousel")) {
          var e = $("#unero-site-content"),
            t = e.find(".unero-post-frame"),
            i = 2,
            o = 0,
            n = 5e3;
          0 < i && --i, 0 < o ? ((n = o), (o = 1)) : (o = 0);
          var a = {
            horizontal: 1,
            smart: 1,
            itemNav: "forceCentered",
            activateOn: "click",
            touchDragging: 1,
            mouseDragging: 1,
            releaseSwing: 1,
            startAt: i,
            scrollBar: e.find(".scrollbar"),
            speed: 1e3,
            elasticBounds: 1,
            dragHandle: 1,
            dynamicHandle: 1,
            clickBar: 1,
            cycleBy: "items",
            cycleInterval: n,
            pauseOnHover: o
          },
            s = new Sly(t, a);
          s.on("load move", function() {
            e.addClass("loaded");
          }), s.init(), $(window)
            .resize(function() {
              var e = $(window).width(), t = e - 60;
              $(document.body).hasClass("boxed") &&
                (e = $(
                  ".site"
                ).width()), 1024 > e && (t = e - 30), 1200 > e ? $(".portfolio-layout-carousel").find(".portfolio-wapper").width(t) : $(".portfolio-layout-carousel").find(".portfolio-wapper").removeAttr("style"), s.reload();
            })
            .trigger("resize");
        }
      })(), g(), $(".to-top").on("click", function() {
        return $("html, body").animate({ scrollTop: 0 }, 800), !1;
      }), (function() {
        if ($("#popup-mailchimp").length) {
          function e() {
            $(document.body).removeClass("modal-open");
            var e = $(".popup-modal.open");
            e.fadeOut(function() {
              $(this).removeClass("open");
            }), $(document.body).trigger("roar_modal_closed", [e]);
          }
          var t = parseInt(theme.popup_mailchimp_period),
            i = parseInt(theme.popup_mailchimp_delay);
          if (
            0 < t &&
            document.cookie.match(/^(.*;)?\s*unero_popup\s*=\s*[^;]+(.*)?$/)
          )
            return;
          (i = Math.max(i, 0)), $(window).on("load", function() {
            setTimeout(function() {
              $(document.body).addClass(
                "modal-open"
              ), $(".popup-modal").fadeIn(), $(".popup-modal").addClass("open");
            }, 1e3 * i);
          }), $(document.body).on("roar_modal_closed", function(e, i) {
            if (i.hasClass("roar-popup")) {
              var o = new Date(), n = o.getTime();
              o.setTime(
                o.getTime() + 24 * t * 60 * 60 * 1e3
              ), (document.cookie =
                "unero_popup=" + n + ";expires=" + o.toGMTString() + ";path=/");
            }
          });
          var o = $("#mc-form.newsletter"), n = o.attr("action");
          o.ajaxChimp({
            url: n,
            callback: function(t) {
              "success" === t.result && e();
            }
          }), $(
            document.body
          ).on("click", ".close-modal, .popup-backdrop", function(t) {
            t.preventDefault(), e();
          }), $(document).on("keyup", function(t) {
            27 === t.keyCode && e();
          });
        }
      })(), $(window).on("load", function() {
        void 0 !== window.notifySettings &&
          ((notifyProIO.settings = {}), (notifyProIO.settings.message =
            window.notifySettings.message), (notifyProIO.settings.hideMobile = !0), (notifyProIO.settings.initialDelay = 3e3), (notifyProIO.settings.displayInterval =
            window.notifySettings.displayInterval), (notifyProIO.settings.displayHold =
            window.notifySettings.displayHold), (notifyProIO.settings.totalPerPage =
            window.notifySettings.totalPerPage), (notifyProIO.settings.totalDisplayed = 0), (notifyProIO.settings.loop = !0), notifyProIO.setup(
            window.notifyProducts
          ));
      }), document.cookie.match(/^(.*;)?\s*unero_cookie\s*=\s*[^;]+(.*)?$/)
        ? $(".cc_container").remove()
        : ($(window).on("load", function() {
            setTimeout(function() {
              $(".cc_container").addClass("open");
            }, 5e3);
          }), $(".cc_btn").click(function(e) {
            e.preventDefault();
            var t = new Date(), i = t.getTime();
            t.setTime(
              t.getTime() + 31536e6
            ), (document.cookie = "unero_cookie=" + i + ";expires=" + t.toGMTString() + ";path=/"), $(".cc_container").removeClass("open");
          })), s(), $(document.body).hasClass("header-mixed-content") &&
        $(".site-content .shopify-section")
          .first()
          .css("margin-top", -$(".site-header").height()), y();
    },
    pageHeader: function() {
      g();
    },
    initLoadMore: function() {
      r(), c(), e(), v(), m(), u(), h(), p(), f(), y();
    }
  };
})()), (theme.init = function() {
  theme.roarApplication.init(), theme.customerTemplates.init(), slate.rte.wrapTable(), slate.rte.iframeReset(), slate.a11y.pageLinkFocus(
    $(window.location.hash)
  ), $(".in-page-link").on("click", function(e) {
    slate.a11y.pageLinkFocus($(e.currentTarget.hash));
  }), $('a[href="#"]').on("click", function(e) {
    e.preventDefault();
  });
});
var roarLookbook = {
  getSizedImageUrl: function(e, t) {
    if (
      (((o = document.createElement("a")).href = e), "cdn.shopify.com" !=
        o.hostname)
    )
      return e;
    if (null == t) return e;
    if ("master" == t) return roarLookbook.removeProtocol(e);
    var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
    if (null != i) {
      var o = e.split(i[0]), n = i[0];
      return roarLookbook.removeProtocol(o[0] + "_" + t + n);
    }
    return null;
  },
  removeProtocol: function(e) {
    return e.replace(/http(s)?:/, "");
  },
  isProductUrl: function(e) {
    var t = window.location.hostname, i = document.createElement("a");
    return (i.href = e), i.hostname == t;
  },
  buildLookbook: function() {
    $(".roarlookbook").each(function(e) {
      var t = $(this);
      if (!t.hasClass("roarlookbook_init")) {
        var i = t.attr("data-lookbook"),
          o = { lookbook: i, action: "lookbook_get" };
        (o = $.param(o)), $.ajax({
          type: "POST",
          url: "/apps/roarlookbook",
          async: !0,
          cache: !1,
          data: o,
          dataType: "json",
          beforeSend: function() {},
          error: function() {},
          success: function(o) {
            t.append(o);
            var n = t.find(".media__blank-preview");
            n.imagesLoaded(function() {
              t
                .addClass("roarlookbook_init")
                .attr("data-lookbook", i + e), n.addClass("sfx-fadeIn");
            });
          }
        });
      }
    });
  },
  resetHotspots: function(e) {
    var t = $(".hotspot", e), i = e.attr("data-lookbook");
    t.each(function() {
      var t = $(this), o = t.attr("data-id"), n = $("#" + i + "-" + o, e);
      n.fadeOut("fast", function() {
        n.remove(), t.removeClass("hotspot_init");
      });
    });
  },
  hotspotPopup: function() {
    $(".roarlookbook").on("click", ".hotspot", function() {
      var e = $(this);
      if (e.hasClass("hotspot_init")) {
        t = e.closest(".roarlookbook");
        roarLookbook.resetHotspots(t);
      } else {
        var t = e.closest(".roarlookbook"),
          i = e.attr("data-id"),
          o = e.closest(".roarlookbook").attr("data-lookbook") + "-" + i,
          n = "#" + e.closest(".roarlookbook").attr("data-lookbook") + "-" + i,
          a = e.attr("data-title"),
          s = e.attr("data-image"),
          r = e.attr("data-price"),
          c = e.attr("data-url"),
          l = "";
        if ("" == a && "" == c) return !1;
        if (
          (roarLookbook.resetHotspots(t), (l +=
            '<div id="' +
            o +
            '" class="hotspot-widget hotspot-loading">'), (l +=
            '<div class="hotspot-content">'), (l +=
            '<span class="hotspot-close">×</span>'), (l +=
            '<div class="hotspot-inner">'), "" != s)
        ) {
          var d =
            '<img src="' +
            roarLookbook.getSizedImageUrl(s, "80x") +
            '" src="' +
            roarLookbook.getSizedImageUrl(s, "300x") +
            '" data-srcset="' +
            roarLookbook.getSizedImageUrl(s, "300x") +
            " 1x, " +
            roarLookbook.getSizedImageUrl(s, "600x") +
            ' 2x" alt="" />';
          l += "" == c ? d : '<a href="' + c + '">' + d + "</a>";
        }
        if (
          ("" != a &&
            ((l += "<h3>"), (l += "" == c
              ? a
              : '<a href="' + c + '">' + a + "</a>"), (l += "</h3>")), "" !=
            r &&
            ((l +=
              '<div class="price"><span class="money">' +
              r +
              "</span></div>"), roarLookbook.isProductUrl(c) &&
              ((l += '<div class="hotspot-btns">'), (l +=
                '<div class="hotspot-btn"><a href="' +
                c +
                '">' +
                theme.apps.details +
                "</a></div>"), (l +=
                '<div class="hotspot-btn"><a class="roar_add_to_cart" href="' +
                c +
                '?add-to-cart=true">' +
                theme.apps.buyNow +
                "</a></div>"), (l += "</div>"))), (l += "</div>"), (l +=
            "</div>"), (l += "</div>"), $(n).length || t.append(l), $(
            n
          ).imagesLoaded(function() {
            var i = $(n),
              o = e.offset().left,
              a = e.offset().top,
              s = i.outerWidth(),
              r = i.outerHeight(),
              c = t.offset().left,
              l = t.offset().top,
              d = "hotspot-right";
            50 > t.outerWidth() - (o + s)
              ? ((o = o - s - 5), (d = "hotspot-left"))
              : (o =
                  o +
                  e.outerWidth() +
                  5), (a = a + e.outerHeight() / 2 - r / 2), i.css({ left: o - c, top: a - l }).removeClass("hotspot-left").removeClass("hotspot-right").addClass(d), e.addClass("hotspot_init"), i.removeClass("hotspot-loading").fadeIn("fast");
          }), $(n).find("img").length)
        ) {
          var u = $(n).find("img");
          u
            .attr("src", u.attr("data-src"))
            .removeAttr("data-src")
            .attr("srcset", u.attr("data-srcset"))
            .removeAttr("data-srcset");
        }
      }
    }), $(document).on("click", ".hotspot-close", function() {
      var e = $(this).closest(".hotspot-widget"),
        t = e.attr("id").split("-")[1];
      $('.roarlookbook .hotspot[data-id="' + t + '"]').removeClass(
        "hotspot_init"
      ), e.fadeOut("fast", function() {
        e.remove();
      });
    }), $(".roarlookbook").on("click", ".image-preview", function() {
      var e = $(this).closest(".roarlookbook");
      roarLookbook.resetHotspots(e);
    }), $(window).resize(function() {
      $(".roarlookbook .hotspot_init").length &&
        $(".roarlookbook .hotspot_init").each(function() {
          $(this).removeClass("hotspot_init").trigger("click");
        });
    });
  },
  addToCart: function() {
    $(document).on("click", ".roar_add_to_cart", function(e) {
      e.preventDefault();
      var t = $(this), i = t.closest(".roarlookbook"), o = t.attr("href");
      $.ajax({
        type: "GET",
        url: o,
        beforeSend: function() {},
        success: function(e) {
          $(e).find('form[action="/cart/add"]').appendTo(i).submit().remove();
        },
        dataType: "html"
      });
    });
  },
  init: function() {
    $(".roarlookbook").length &&
      (roarLookbook.buildLookbook(), roarLookbook.hotspotPopup(), roarLookbook.addToCart());
  }
};
try {
  $(theme.init), roarLookbook.init();
} finally {
  var $unloader = $("#un-before-unloader");
  $(window).on("beforeunload", function() {
    $unloader.removeClass("out").fadeIn(500, function() {
      $unloader.addClass("loading");
    });
  }), $unloader.fadeOut(200, function() {
    $unloader.addClass("out");
  });
}


$(document).ready(function() {

  $('body').on('click', '[name="checkout"], [name="goto_pp"], #create_customer [name="register"] ', function() {
    if ($('#agree').is(':checked')) {
      $(this).submit();
    }
    else {
      alert("You must agree with the terms and conditions.");
      return false;
    }
  });
  
  $('.home-video .volume-control').on('click', function(){
  	var video = $(this).siblings('video');
    if( $(video).prop('muted') ) {
      $(video).prop('muted', false);
      $(this).removeClass('muted');
    } else {
      $(video).prop('muted', true);
      $(this).addClass('muted');
    }
  });
});
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
  }
}